// noinspection SpellCheckingInspection

const appName = "REVOO";

export const it = {
  ActivityStatistics: {
    title: "Attività dei clienti",
    columns: {
      customer: "Cliente",
      workouts: "Workout svolti",
      last: "Ultimo svolto",
    },
  },
  AssignedPlans: {
    name: "Nome",
    assigned_list_sort_end_asc: "Data di scadenza (crescente)",
    assigned_list_sort_end_desc: "Data di scadenza (decrescente)",
    assigned_list_sort_name_asc: "Nome (A → Z)",
    assigned_list_sort_name_desc: "Nome (Z → A)",
    assigned_list_sort_menu_aria:
      "Scegli come ordinare i piani di allenamento assegnati",
    cards: "Schede",
    duration: "Durata",
    last_satisfaction: "Feedback Ultimo Allenamento",
    level: "Livello",
    deleteModal: {
      title_one: "Vuoi eliminare l'assegnazione selezionata?",
      title_other: "Vuoi eliminare le assegnazioni selezionate?",
      subtitle_one:
        "Procedendo <strong>eliminerai</strong> l'assegnazione dalla lista.",
      subtitle_other:
        "Procedendo <strong>eliminerai</strong> le assegnazioni selezionate.",
    },
  },
  AssignedNutritionPlans: {
    name: "Piano",
    days: "Giorni",
    duration: "Durata",
    energy: "Energia",
    weekly_average: "Media settimanale",
    customer_ids: "ID Cliente/i",
    group_ids: "ID Gruppo/i",
    not_assigned: "Non assegnato",
    label_selected: "Selezionati",
    list: "Piani nutrizionali assegnati",
    empty: "Nessun piano nutrizionale assegnato",
  },
  Calendar: {
    add_event: "Aggiungi evento",
    add_participants: "Aggiungi partecipanti",
    add_email: "Aggiungi email",
    appointment: "Appuntamento",
    calendar: "Calendario",
    delete_appointment: "Elimina appuntamento",
    delete_event_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente evento dalla lista.",
    delete_event_title: "Vuoi eliminare questo evento?",
    edit_event: "Modifica evento",
    end_hour: "Ora fine",
    end: "Fine",
    event_date: "Data evento",
    event_delete: "Elimina evento",
    event_edit: "Modifica evento",
    event_notes: "Note evento",
    event_title: "Titolo evento",
    event: "Evento",
    in_person: "Di persona",
    link_videocall: "Link videocall",
    location: "Luogo",
    new_event: "Nuovo evento",
    notify_before: "Notifica prima",
    notify_participants: "Notifica gli invitati",
    participants: "Partecipanti",
    phone_call: "Chiamata",
    reminder: "Promemoria",
    start_hour: "Ora inizio",
    start: "Inizio",
    success_create_event_subtitle: "Evento creato con successo",
    success_delete_event_subtitle: "Evento eliminato con successo",
    success_edit_event_subtitle: "Evento modificato con successo",
    videocall: "Videocall",
    addEvent: "Aggiungi evento",
    agenda: "Agenda",
    create_error_subtitle: "Evento non creato",
    create_error_title: "Errore creazione evento",
    create_success_subtitle: "Evento creato con successo",
    create_success_title: "Evento creato",
    day: "Giorno",
    edit_error_subtitle: "Evento non modificato",
    edit_error_title: "Errore modifica evento",
    edit_success_subtitle: "Evento modificato con successo",
    edit_success_title: "Evento modificato",
    update_status_customer: "Aggiorna stato cliente",
    update_status_customer_success: "Stato cliente aggiornato con successo",
    error_subtitle: "Lista eventi non caricata",
    error_title: "Errore eventi",
    month: "Mese",
    other_one: "Altro evento",
    other_other: "+ Altri {{count}}",
    today: "Oggi",
    week: "Settimana",
  },
  Check: {
    empty: "Dati non completi",
    unit: {
      years: " anni",
      degrees: "°",
      kilograms: "kg",
      grams: "g",
      centimeters: "cm",
      millimeters: "mm",
      meters: "m",
      percentage: "%",
      calories: "kcal",
      age: " età",
    },
    filters: {
      date: "Situazione al",
      all: "Ultimi inseriti",
    },
    protocol: {
      "3_female": "3 Pliche - Donna",
      "3_male": "3 Pliche - Uomo",
      "7_male": "7 Pliche - Uomo",
      "7_female": "7 Pliche - Donna",
    },
    measurementSection: "Misure corpo",
    compositionSection: "Composizione Massa",
    labels: {
      muscle: "Muscolare",
      fat: "Grassa",
      bone: "Ossea",
    },
    compositions: {
      modalUser: "Cliente: {{name}} {{surname}}",
      title: "Composizione",
      edit: "Modifica",
      isEmpty: "Nessuna composizione presente",
      data: "Dati",
    },
    compositionsStore: {
      new: "Nuova composizione",
      edit: "Modifica composizione",
      delete: "Elimina",
      error: "Errore composizione",
      errorDelete: "Errore eliminazione composizione",
      success: "Composizione salvata con successo",
      successDelete: "Composizione eliminata con successo",
      date: "Data composizione",
      overrideDateMessage:
        "In questa data sono già presenti delle composizioni, vuoi sovrascriverle?",
    },
    measurements: {
      modalUser: "Cliente: {{name}} {{surname}}",
      title: "Misure",
      dx: "DX",
      sx: "SX",
      edit: "Modifica",
      isEmpty: "Nessuna misura presente",
      data: "Dati",
    },
    measurementsStore: {
      new: "Nuove misure",
      edit: "Modifica misure",
      delete: "Elimina",
      error: "Errore nelle misure",
      errorDelete: "Errore eliminazione misure",
      success: "Misure salvate con successo",
      successDelete: "Misure eliminate con successo",
      date: "Data misurazione",
      overrideDateMessage:
        "In questa data sono già presenti delle misurazioni, vuoi sovrascriverle?",
    },
    health: {
      modalUser: "Cliente: {{name}} {{surname}}",
      title: "Dati monitoraggio salute",
      average: "Media",
      edit: "Modifica",
      results: "Risultato",
      isEmpty: "Nessun dato sincronizzato con l'app di allenamento",
      body_fat: {
        "7_female": "Massa Grassa (JP-7/woman)",
        "3_female": "Massa Grassa (JP-3/woman)",
        "3_male": "Massa Grassa (JP-3/man) ",
        "7_male": "Massa Grassa (JP-7/man)",
      },
    },
    plicometries: {
      modalUser: "Cliente: {{name}} {{surname}}",
      title: "Plicometrie",
      average: "Media",
      edit: "Modifica",
      results: "Risultato",
      isEmpty: "Nessuna plicometria presente",
      body_fat: {
        "7_female": "Massa Grassa (JP-7/woman)",
        "3_female": "Massa Grassa (JP-3/woman)",
        "3_male": "Massa Grassa (JP-3/man) ",
        "7_male": "Massa Grassa (JP-7/man)",
      },
    },
    plicometriesStore: {
      new: "Nuova plicometria",
      edit: "Modifica plicometria",
      delete: "Elimina",
      error: "Errore plicometria",
      errorDelete: "Errore eliminazione plicometria",
      success: "Plicometria salvata con successo",
      successDelete: "Plicometria eliminata con successo",
      date: "Data plicometria",
      overrideDateMessage:
        "In questa data sono già presenti delle plicometrie, vuoi sovrascriverle?",
    },
    modalDetails: {
      lastMeasurement: "Ultima rilevazione",
      deviation: "Scostamento",
      history: "Storico",
      seeAll: "Vedi tutti",
      summary: "Riepilogo",
      date: "Data",
      value: "Valore",
      filters: {
        last12months: "Ultimi 12 mesi",
        last6months: "Ultimi 6 mesi",
        last3months: "Ultimi 3 mesi",
        lastMonth: "Ultimo mese",
        all: "Tutti",
      },
      graphEmpty: "Nessun dato da mostrare",
      historyEmpty: "Nessun dato da mostrare",
    },
    PhotoProgress: {
      isEmpty: "Nessuna foto presente",
      photo: "Foto",
      gallery: "Galleria foto",
      form: {
        date: "Seleziona data rilevazione*",
        front_view: "Frontale",
        rear_view: "Dorsale",
        right_view: "Laterale Destro",
        left_view: "Laterale Sinistro",
      },
      delete: {
        modal: {
          title: "Vuoi eliminare <br />le foto selezionate?",
          description: "Procedendo <b>le perderai</b> definitivamente",
        },
        successMessage: {
          title: "Foto cancellate con successo",
        },
        errorMessage: {
          title: "Errore durante la cancellazione delle foto",
        },
      },
      create: {
        modal: {
          title: "Foto progressi",
          modalUser: "Cliente: {{name}} {{surname}}",
        },
        successMessage: {
          title: "Foto caricate con successo",
        },
        errorMessage: {
          title: "Errore durante l'inserimento delle foto",
        },
      },
      compare: {
        modal: {
          title: "Compara foto",
          modalUser: "Cliente: {{name}} {{surname}}",
        },
      },
    },
  },
  Customers: {
    insert_attachment: "Inserisci Allegato",
    start_date: "Data di inizio",
    end_date: "Data di fine",
    athlete_name: "Nome Atleta",
    combination: "Combinazione",
    set: "Set",
    exercise: "Esercizio",
    reps: "Reps",
    weight: "Peso",
    tut: "TUT",
    rest: "Rest",
    intensity: "Intensità",
    end: "Fine",
    notes: "Note",
    subscriptions_note: "Note abbonamento",
    plan_name: "Nome piano",
    no_workout_plans: "Nessun piano di allenamento",
    no_subscriptions: "Nessuna sottoscrizione",
    no_notes: "Nessuna nota",
    group_members: "Partecipanti del gruppo",
    add_member_success: "Membro aggiunto con successo",
    remove_member_success: "Membro rimosso con successo",
    subscriptionsNote: {
      title: "Nota Abbonamenti",
      successEditNote: "Nota modificata con successo",
    },
    histories: {
      form: {
        allergies: "Allergie",
        asthma: "Asma",
        blood_group: "Gruppo sanguigno",
        contraceptive_pill: "Pillola contraccettiva",
        diabetes: "Diabete",
        diagnosed_pathologies: "Patologie diagnosticate",
        disorders: "Disturbi alimentari",
        drugs: "Farmaci",
        fractures: "Fratture",
        goal: "Obiettivo",
        goal_description: "Descrizione obiettivo",
        height: "Altezza",
        intestinal_irregularity: "Irregolarità intestinale",
        intolerance: "Intolleranze",
        irregular_periods: "Ciclo irregolare",
        job: "Professione",
        last_revelation: "Ultima rivelazione",
        lifestyle: "Stile di vita",
        mmhg: "Pressione arteriosa",
        other_pathologies: "Altre patologie",
        postural: "Problemi posturali",
        problems_cardiac: "Problemi cardiaci",
        problems_thyroid: "Problemi tiroidei",
        sport: "Attività fisica",
        supplements: "Utilizzo integratori",
        supply: "Alimentazione",
        surgical: "Interventi chirurgici",
        weight: "Peso",
        workout_freq: "Frequenza allenamento",
        workout_location: "Luogo allenamento",
        workout_location_option: {
          gym: "Palestra",
          home_gym: "Palestra casalinga",
          at_home_with_minimal_equipment: "In casa con poca attrezzatura",
          outdoors: "All'aperto",
          other: "Altro",
        },
        workout_freq_option: {
          one: "1 volta a settimana",
          two: "2 volte a settimana",
          three: "3 volte a settimana",
          four: "4 volte a settimana",
          five: "5 volte a settimana",
          six: "6 volte a settimana",
          seven: "7 volte a settimana",
        },
        goal_option: {
          fat_loss: "Perdita di grasso",
          definition: "Definizione",
          muscle_mass: "Aumento massa muscolare",
          athletic_preparation: "Preparazione atletica",
          rehabilitation: "Riabilitazione",
          postural_correction: "Correzione posturale",
          other: "Altro",
        },
        lifestyle_option: {
          lethargic: "Letargico",
          sedentary: "Sedentario",
          slightly_active: "Poco attivo",
          active: "Attivo",
          very_active: "Molto attivo",
          extremely_active: "Estremamente attivo",
        },
      },
      error: {
        get: {
          title: "Errore Anamnesi",
          subtitle: "Anamnesi non caricata",
        },
        create: {
          title: "Errore Anamnesi",
          subtitle: "Anamnesi non creata",
        },
        edit: {
          title: "Errore Anamnesi",
          subtitle: "Anamnesi non modificata",
        },
        delete: {
          title: "Errore Anamnesi",
          subtitle: "Anamnesi non eliminata",
        },
      },
      success: {
        create: {
          title: "Anamnesi creata",
          subtitle: "Anamnesi creata con successo",
        },
        edit: {
          title: "Anamnesi modificata",
          subtitle: "Anamnesi modificata con successo",
        },
        delete: {
          title: "Anamnesi eliminata",
          subtitle: "Anamnesi eliminata con successo",
        },
      },
      title: "Anamnesi",
      add_history: "Aggiungi anamnesi",
      label_empty_table: "Nessuna anamnesi trovata",
      draft: "(bozza)",
      created_at: "Data",
      created_by: "Creata da",
      filled_by: "Compilato da",
      edit_history: "Modifica anamnesi",
      new_history: "Nuova anamnesi",
      duplicate_history: "Duplica anamnesi",
      view_history: "Visualizza anamnesi",
      new: {},
      edit: {},
      delete: {
        title: "Vuoi eliminare <br />l'anamnesi selezionata?",
        description: "Procedendo <strong>la perderai</strong> definitivamente",
      },
    },
    assign_video: "Assegna Video",
    error: {
      get_customers_title: "Errore clienti",
      get_customers_subtitle: "Impostazioni clienti non caricate",
    },
    weeks_duration: "Durata in settimane",
    executed_days: "Giorni eseguiti",
    workouts: "Allenamenti",
    per_side: "x Lato",
    side_left_short: "SX",
    side_right_short: "DX",
    workout_feedback: "Feedback allenamento",
    method: {
      time_circuit: "Circuito a tempo",
      normal: "Singolo",
      emom: "EMOM",
      circuit: "Circuito",
      superset: "Superset",
    },
    email_already_assigned_alert: {
      title: "Email già associata",
      message:
        "Questa mail è già associata ad un altro PT. Sei sicuro di voler aggiungere il cliente? Il cliente riceverà una mail per accettare la creazione del suo account.",
      confirm: "Conferma",
      cancel: "Annulla",
    },
    customer_deleted_alert: {
      message:
        "Questa email è associata a un cliente che è stato cancellato dal sistema. Per procedere, utilizza un'altra email o modifica i dati del cliente.",
      ok: "Ho capito",
    },
    customer_already_owned_alert: {
      message:
        "Questo cliente è già associato al tuo account. Controlla la lista dei tuoi clienti o utilizza un'altra email per crearne uno nuovo.",
      ok: "Ho capito",
    },
    pending_migration_alert: {
      message:
        "È già presente una richiesta di migrazione per questo cliente. La richiesta è in elaborazione e riceverai una notifica una volta completata.",
      ok: "Ho capito",
    },
    sets: "Sets",
    card: "Scheda",
    card_list: "Elenco schede",
    training_plans: "Piani di allenamento",
    executed_workouts: "Allenamenti eseguiti",
    activate_training_plan: "Piano di allenamento attivo",
    activate_training_plan_success:
      "Piano di allenamento attivato con successo",
    deactivate_training_plan: "Disattiva piano di allenamento",
    deactivate_training_plan_success:
      "Piano di allenamento disattivato con successo",
    edit_equipment: "Modifica attrezzatura",
    edit_equipment_success: "Attrezzatura modificata con successo",
    last: "Ultimo",
    active_plan: "Piano attivo",
    inactive_plan: "Piano non attivo",
    group_plan_active_one:
      "Piano del gruppo «{{groups}}» di cui il cliente fa parte. Si attiva e disattiva dal gruppo.",
    group_plan_active_other:
      "Piano dei gruppi «{{groups}}» di cui il cliente fa parte. Si attiva e disattiva dal gruppo.",
    group_plan_inactive_one:
      "Piano del gruppo «{{groups}}» di cui il cliente fa parte. Disattivato dal gruppo.",
    group_plan_inactive_other:
      "Piano dei gruppi «{{groups}}» di cui il cliente fa parte. Disattivato dal gruppo.",
    activate_plan_to_notify: "Attiva il piano per inviare notifiche",
    notification_sent: "Notificato",
    notify_training_plan: "Notifica piano di allenamento",
    notify_training_plan_success:
      "Notifica piano di allenamento inviata con successo",
    send_notification: "Invia notifica",
    equipment: "Attrezzatura",
    create_training_plan: "Crea piano di allenamento",
    assigned_training_plans: "Piani di allenamento assegnati",
    count_workouts_zero: "Non ci sono allenamenti svolti",
    count_workouts_one: "{{count}} allenamento",
    count_workouts_other: "{{count}} allenamenti",
    count_events_zero: "Non ci sono eventi",
    count_events_one: "{{count}} evento",
    count_events_other: "{{count}} eventi",
    calendar: "Calendario",
    add_event: "Aggiungi evento",
    manage_groups: "Gestisci gruppi",
    create_subscription: "Crea abbonamento",
    create_subscription_success: "Abbonamento creato con successo",
    payment_date: "Data pagamento",
    settled_payment: "Pagamento saldato",
    subscription_payment: "Pagamento abbonamento",
    draft: "(bozza)",
    deactivate_customer_title:
      "Disattiva il cliente allo scadere dell'abbonamento",
    deactivate_customer_subtitle:
      "Non puoi effettuare questa operazione se l'abbonamento è già scaduto",
    duration_type_days: "Giorni",
    duration_type_weeks: "Settimane",
    duration_type_months: "Mesi",
    duration_type: "Tipo durata",
    date_of_start: "Data di inizio",
    subscriptions_active: "Attivi",
    subscriptions_expired: "Terminati",
    subscription: "Abbonamento",
    add_subscription: "Aggiungi abbonamento",
    edit_subscription: "Modifica abbonamento",
    edit_subscription_success: "Abbonamento modificato con successo",
    label_empty_notes_table: "Nessuna nota trovata",
    delete_note: "Elimina nota",
    delete_note_success: "Nota eliminata con successo",
    delete_note_title: "Vuoi eliminare questa nota?",
    delete_subscription: "Elimina abbonamento",
    delete_training_plan: "Elimina piano di allenamento",
    delete_training_plan_success: "Piano di allenamento eliminato con successo",
    delete_training_plan_title: "Vuoi eliminare questo piano di allenamento?",
    delete_training_plan_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente piano di allenamento dalla lista.",
    delete_subscription_title: "Vuoi eliminare questo abbonamento?",
    delete_subscription_success: "Abbonamento eliminato con successo",
    delete_note_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> la seguente nota dalla lista.",
    delete_subscription_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente abbonamento dalla lista.",
    important: "Importante",
    create_note: "Crea nota",
    create_note_success: "Nota creata con successo",
    text: "Testo",
    title: "Titolo",
    low: "Bassa",
    medium: "Media",
    high: "Alta",
    priority: "Priorità",
    detail_note: "Dettaglio nota",
    add_note: "Aggiungi nota",
    edit_note: "Modifica nota",
    edit_note_success: "Nota modificata con successo",
    joined_at: "Inserito dal {{date}}",
    unpaid: "Non pagato",
    price: "Prezzo",
    start: "Inizio",
    manage: "Gestisci",
    subscriptions: "Abbonamenti",
    active_subscriptions: "Abbonamenti attivi",
    no_surveys_label: "Non ci sono questionari",
    no_groups_label: "Non ci sono gruppi",
    surveys: "Questionari",
    important_notes: "Note importanti",
    add: "Aggiungi",
    next_meeting: "Prossimo appuntamento",
    last_workout: "Ultimo allenamento",
    see_all: "Vedi tutti",
    reset_password: "Reset Password",
    active_profile: "Profilo attivo",
    edit_goals: "Modifica obiettivi",
    success_edit_goals: "Obiettivi aggiornati con successo",
    goal: "Obiettivo",
    goals: "Obiettivi",
    goals_to_achieve: "Obiettivi da raggiungere",
    edit: "Modifica",
    send_message: "Invia messaggio",
    label_empty_assigned_video_list: "Nessun video assegnato",
    label_empty_playlist_list: "Nessuna playlist assegnata",
    no_expiration: "Nessuna scadenza",
    expired: "Scaduto",
    remove_assign_label: "Vuoi rimuovere l'assegnazione da questo cliente?",
    remove_user_from_group: "Vuoi rimuovere il cliente dal gruppo?",
    missing_days: "Scade tra {{count}} giorni",
    active_from: "Attivo dal",
    weeks: "{{ count }} settimane",
    months: "{{ count }} mesi",
    days: "{{ count }} giorni",
    duration: "Durata",
    type: {
      onSiteAndRemote: "Dal vivo e remoto",
      onSite: "Dal vivo",
      online: "Da remoto",
      remote: "Da remoto",
    },
    tabs: {
      summary: "Riepilogo",
      check: "Check",
      media: "Media",
      training_plans: "Allenamenti",
      nutrition_plans: "Nutrizione",
      surveys: "Questionari",
      shared_folder: "Cartella condivisa",
      mobile_section_caption: "Sezione",
    },
    goal_type: {
      fat_loss: "Perdere Grasso",
      mass_gain: "Aumentare Massa",
      definition: "Definizione",
      athletic_training: "Allenamento Aerobico",
      rehabilitation: "Riabilitazione",
      postural_correction: "Ginnastica Posturale",
      other: "Altro",
    },
    export_training_plan: "Esporta piano di allenamento",
    export_training_plan_success: "Piano di allenamento esportato con successo",
    export_training_plan_loading: "Esportazione in corso",
    video_list: "Lista video assegnati",
    playlists_list: "Lista playlists assegnate",
    training_deadline: "Scadenza allenamento",
    list: "Lista clienti",
    add_assignment: "Aggiungi Assegnazione",
    remove_assignment: "Rimuovi Assegnazione",
    edit_assignment: "Modifica Assegnazione",
    add_assignment_success: "Assegnazione creata con successo",
    remove_assignment_success: "Assegnazione rimossa con successo",
    edit_assignment_success: "Assegnazione modificata con successo",
    add_customer: "Aggiungi cliente",
    error_customers: "Errore Clienti",
    error_customers_subtitle: "Lista clienti non caricata",
    error_customer_subtitle: "Nuovo cliente non creato",
    email_unavailable:
      "Questo indirizzo email non può essere usato per un nuovo cliente. Usane un altro o contatta l'assistenza.",
    error_customer_label: "Operazione su cliente non riuscita",
    error_groups: "Errore Gruppi",
    error_groups_subtitle: "Lista gruppi non caricata",
    success_customer_subtitle: "Nuovo cliente creato con successo",
    delete_customer_success: "Cliente eliminato con successo",
    success_reset_password: "Password resettata con successo",
    invite: "Invita",
    customer_name: "Nome cliente",
    update_status_customer: "Aggiorna stato cliente",
    update_status_customer_success: "Stato cliente aggiornato con successo",
    groups: "Gruppi",
    group: "Gruppo",
    status: "Stato",
    expiry_date: "Scadenza allenamento",
    select_range_date: "Seleziona un range di date",
    status_active: "Attivo",
    status_inactive: "Inattivo",
    status_no_training: "Mai allenato",
    status_disabled: "Disattivato",
    status_not_very_active: "Poco attivo",
    total_count: "clienti",
    active_count: "attivi",
    label_selected: "selezionati",
    no_groups: "Nessun gruppo",
    new_customer: "Nuovo cliente",
    edit_customer: "Modifica cliente",
    edit_customer_success: "Cliente modificato con successo",
    profile_image: "Immagine profilo",
    choose_image: "Scegli immagine",
    profile_data: "Dati profilo",
    personal_data: "Dati anagrafici",
    delete_customer: "Elimina cliente",
    delete_customer_title: "Vuoi eliminare questo cliente?",
    delete_customer_subtitle:
      "Procedendo perderai tutti i dati, allenamenti associati.",
    open_link: "Apri link",
    shared_folder: "Cartella condivisa",
    shared_folder_url: "Url Cartella condivisa",
    address: "Indirizzo",
    fiscal_code: "Codice fiscale",
    contact_data: "Dati contatto",
    phone: "N. Cellulare",
    prefix: "Prefisso",
    other_info: "Altre informazioni",
    chat: "Chat",
    customer_type: "Tipo cliente",
    how_did_he_meet_you: "Come ti ha conosciuto?",
    email: "Email",
    first_name: "Nome",
    last_name: "Cognome",
    gender: "Sesso",
    date_of_birth: "Data di nascita",
    country: "Paese",
    birth_date: "Data di nascita",
    copy_email: "Copia email",
    select_all_button_one: `Seleziona il cliente esistente`,
    select_all_button_other: `Seleziona tutti i {{count}} clienti esistenti`,
    select_all_one: `Hai selezionato {{count}} cliente.`,
    select_all_other: `Hai selezionato {{count}} clienti.`,
    select_all_total: `Tutti i {{count}} clienti sono stati selezionati`,
    cancel_all: `Annulla selezione`,
  },
  Dashboard: {
    error: {
      get_dashboard_title: "Errore Dashboard",
      get_dashboard_subtitle: "Dati Dashboard non caricati",
      update_dashboard_title: "Errore aggiornamento Dashboard",
      update_dashboard_subtitle: "Dati Dashboard non aggiornati",
    },
    success: {
      update_dashboard_title: "Dati Dashboard aggiornati",
      update_dashboard_subtitle: "Dati Dashboard aggiornati con successo",
    },
    hello: "Ciao {{name}}",
    referral: {
      title: "Porta un amico trainer in REVOO e risparmia sul tuo abbonamento.",
      subtitle: "Come funziona?",
    },
    note: {
      title: "Note",
    },
    activities: {
      table: {
        column: {
          customer: "Cliente",
          event: "Evento",
          created_at: "Data",
        },
        filter: {
          period: "Periodo",
        },
      },
      period: {
        today: "Oggi",
        last_week: "Ultima settimana",
      },
      title: "Attività clienti",
      summary: {
        title: "Ultime attività clienti",
        see_all: "Vedi attività",
        empty: "Nessuna attività cliente",
      },
      events: {
        new_executed_workout: "Completamento piano di allenamento",
        new_executed_workout_with_feedback:
          "Completamento piano di allenamento con feedback",
        new_history: "Inserimento anamnesi",
        new_measurement: "Inserimento misurazioni",
        new_form_submission: "Inserimento questionario {{ name }}",
        new_photo_progress: "Inserimento foto progressi",
        new_customer_from_invitation_code:
          "Registrazione utente tramite codice invito",
      },
    },
    deadlines: {
      table: {
        column: {
          instance_type: "Tipo scadenza",
          start: "Termine",
          end: "Data scadenza",
        },
        filter: {
          instance_type: "Tipo scadenza",
          period: "Data scadenza",
        },
        days: "{{ count }} giorni",
        expired: "Terminato",
      },
      period: {
        last_two_weeks: "Ultimi 14 giorni",
        next_two_weeks: "Prossimi 14 giorni",
        last_week: "Ultimi 7 giorni",
        next_week: "Prossimi 7 giorni",
      },
      instance_type: {
        customer_subscriptions: "Abbonamenti",
        playlist_assignments: "Playlist",
        training_cards: "Piani di allenamento",
        vod_assignments: "Video on demand",
      },
      tabs: {
        expired: "Scadute",
        expiring: "In scadenza",
      },
      title: "Scadenze",
      summary: {
        title: "Prossime scadenze",
        see_all: "Vedi scadenze",
      },
      counters: {
        customer_subscriptions: "Abbonamenti",
        playlist_assignments: "Playlist",
        training_cards: "Piani di allenamento",
        vod_assignments: "Video on demand",
      },
    },
    events: {
      title: "In calendario",
      subtitle: "Oggi",
      see_all: "Vedi calendario",
      empty: "Nessun appuntamento in calendario oggi",
    },
    messages: {
      title: "Nuovi Messaggi",
      see_all: "Vedi messaggi",
    },
    tabs: {
      activities: "Attività",
      statistics: "Statistiche",
    },
  },
  TagsLibrary: {
    title: "Tipi Esercizio",
    add_tag: "Nuovo tipo esercizio",
    edit_tag: "Modifica tipo esercizio",
    name: "Nome",
    select_all_button_one: `Seleziona il tipo esercizio esistente`,
    select_all_button_other: `Seleziona tutti i {{count}} tipi esercizio esistenti`,
    label_selected: "Selezionati",
    label_empty_tags_table: "Nessun tipo esercizio trovato",
    deleteModal: {
      title_one: "Vuoi eliminare il tipo esercizio selezionato?",
      title_other: "Vuoi eliminare i tipi esercizio selezionati?",
      subtitle_one:
        "Procedendo <strong>eliminerai</strong> il tipo esercizio dalla lista. <br /> e non apparirà più nei piani e modelli creati.",
      subtitle_other:
        "Procedendo <strong>eliminerai</strong> i tipi esercizio selezionati. <br /> e non appariranno più nei piani e modelli creati.",
    },
    error: {
      get_tags: "Errore tipi esercizio",
      get_tags_subtitle: "Lista tipi esercizio non caricata",
      create_tags: "Errore crea tipo esercizio",
      create_tags_subtitle: "Nuovo tipo esercizio non creato",
      edit_tags: "Errore modifica tipo esercizio",
      edit_tags_subtitle: "Tipo esercizio non modificato",
      delete_tags: "Errore elimina tipo esercizio",
      delete_tags_subtitle: "Tipo esercizio non eliminato",
    },
    success: {
      success_tags: "Tipo esercizio creato con successo",
      success_tags_subtitle: "Tipo esercizio creato con successo",
      success_tags_edit: "Tipo esercizio modificato con successo",
      success_tags_edit_subtitle: "Tipo esercizio modificato con successo",
      delete_tags: "Eliminazione tipo esercizio",
      delete_tags_subtitle: "Tipo esercizio eliminato con successo",
    },
  },
  ExerciseLibrary: {
    title: "Libreria Esercizi",
    add: "Nuovo esercizio",
    error: {
      create_exercise: "Errore crea esercizio",
      create_exercise_subtitle: "Nuovo esercizio non creato",
      error_exercises: "Errore esercizi",
      error_exercises_subtitle: "Lista esercizi non caricata",
      delete_exercises: "Errore elimina esercizi",
      delete_exercises_subtitle: "Esercizi non eliminati",
      get_exercise: "Errore esercizio",
      get_exercises_subtitle: "Esercizio non caricato",
      edit_exercise: "Errore modifica esercizio",
      edit_exercise_subtitle: "Esercizio non modificato",
      update_base_exercises_title: "Errore libreria",
      update_base_exercises_subtitle: "Libreria non aggiornata",
    },
    success: {
      success_exercise: "Esercizio creato con successo",
      success_exercise_subtitle: "Esercizio creato con successo",
      success_exercises: "Esercizi creati con successo",
      success_exercises_subtitle: "Esercizi creati con successo",
      delete_exercises: "Eliminazione esercizi",
      delete_exercises_subtitle: "Esercizi eliminati con successo",
    },
    select_all_one: `Hai selezionato {{count}} esercizio.`,
    select_all_other: `Hai selezionato {{count}} esercizi.`,
    select_all_total: `Tutti i {{count}} esercizi sono stati selezionati`,
    select_all_button_one: `Seleziona l'esercizi esistenti`,
    select_all_button_other: `Seleziona tutti gli {{count}} esercizi esistenti`,
    cancel_all: `Annulla selezione`,
    exercise_name: "Nome esercizio",
    delete: "Elimina",
    label_selected: "selezionati",
    base: "Visualizza libreria REVOO",
    tags: "Tipo esercizio",
    combine_tags: "Combina",
    combine_tags_hint:
      "Mostra solo gli esercizi che includono tutti i tag selezionati",
    deleteModal: {
      title_one: "Vuoi eliminare l'esercizio selezionato?",
      title_other: "Vuoi eliminare gli esercizi selezionati?",
      subtitle_one:
        "Procedendo <strong>eliminerai</strong> l'esercizio dalla lista. <br /> e non apparirà più nei piani e modelli creati.",
      subtitle_other:
        "Procedendo <strong>eliminerai</strong> gli esercizi selezionati. <br /> e non appariranno più nei piani e modelli creati.",
    },
    exerciseStore: {
      add: "Nuovo esercizio",
      edit: "Modifica esercizio",
      duplicate: "Duplica esercizio",
      info_message:
        "I tuoi esercizi sono privati. Nessun altro Personal Trainer potrà vederli.",
      youtube_warning_existing_title:
        "I video YouTube non sono più supportati a causa di nuove limitazioni sulla condivisione esterna. Per salvare le modifiche all'esercizio è necessario sostituire il link.",
      youtube_warning_new_title:
        "I video di YouTube non sono attualmente supportati a causa di nuove limitazioni sulla condivisione esterna. Ti invitiamo a usare un link da un'altra piattaforma.",
      external_link_not_supported:
        "I link a piattaforme esterne non sono più supportati. Rimuovi il link per salvare le modifiche",
      cloudflare_link_only:
        "Sono ammessi solo link video di Cloudflare Stream (es. watch.cloudflarestream.com o customer-*.cloudflarestream.com)",
      name: "Nome esercizio",
      tags: "Tipo esercizio",
      note: "Descrizione",
      link: "Link video Cloudflare",
      thumbnail_image: "Foto Copertina",
      video: "Video",
      max_size: "Max {{size}}",
    },
  },
  FeatureFlags: {
    accepted: "Accettato",
    not_accepted: "Non accettato",
    submit: "Accetta e continua",
    contact: "Hai dubbi? Contattaci",
    title: "Aggiornamenti alla nostra privacy policy",
    description:
      "Per continuare a garantirti un servizio ottimale, abbiamo aggiornato l'informativa privacy che ti chiediamo di leggere e accettare",
    paddle_payment:
      "Abbiamo aggiornato il nostro sistema di pagamento, passando da Stripe a Paddle, per offrirti una gestione più semplice ed efficiente del tuo abbonamento.<br><br>" +
      "✅ Cosa cambia per te?<br>" +
      "Migliore gestione dell'abbonamento e delle fatture<br>" +
      "Maggiore trasparenza e protezione dei dati<br>" +
      "Fatture emesse direttamente da Paddle, il nuovo sistema di pagamento <br>" +
      "<br>" +
      "🔹 Cosa NON cambia?<br>" +
      "Il tuo abbonamento rimane attivo senza modifiche: il prezzo e le condizioni restano gli stessi. Aggiornando i dati non verrà effettuato nessun addebito.<br>" +
      "<br>" +
      "🔹 Cosa devi fare?<br>" +
      "Per continuare a utilizzare il servizio senza interruzioni, clicca sul bottone <b>Aggiorna dati pagamento</b> e inserisci i tuoi dati.<br><br>" +
      "📌 Bastano pochi secondi!",
    data_processor: {
      title: "La privacy dei tuoi atleti è importante",
      description:
        "Per poterti condividere alcune informazioni che i tuoi clienti inseriranno nell'app REVOO, la legge richiede che REVOO ti nomini responsabile esterno del trattamento ai sensi dell'art. 28 del Regolamento UE 2016/679. Ti chiediamo di prendere visione del documento di seguito, che trovi riportato integralmente nella tua area personale.",
      policy: `**NOMINA A RESPONSABILE ESTERNO DEL TRATTAMENTO**

*in applicazione dell'**art. 28 del Regolamento (UE) 2016/679*** *relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali e di libera circolazione di tali dati e dell'ulteriore normativa nazionale ed europea in quanto applicabile*

**PREMESSO CHE**

1) **REVOO S.r.l.**, con sede legale in Milano (MI), Via Monte Napoleone n. 10, C.F. e P.IVA 10079510961 (di seguito "Titolare"), in persona del proprio legale rappresentante *pro tempore*, ha stipulato con l'utente opportunamente identificato tramite l'indirizzo email [EMAIL] (di seguito "Cliente") un contratto avente ad oggetto la prestazione di servizi informatici erogati tramite la piattaforma web e/o applicazione mobile "REVOO" ([https://www.revoo-app.com/](https://www.revoo-app.com/)) (di seguito, rispettivamente, "Contratto" e "Piattaforma");   
2) nell'ambito della fruizione dei servizi di cui al Contratto, il Cliente potrebbe trattare - mediante la raccolta e il caricamento nella Piattaforma - dati personali di soggetti terzi (clienti del Cliente) utilizzatori della Piattaforma (di seguito "Trattamento" e "Dati");  
3) il Titolare è il centro di imputazione giuridica del trattamento dei dati personali concernenti gli utilizzatori della Piattaforma;  
4) le esigenze organizzative del Titolare richiedono di definire le sfere di autonomia e di responsabilità in materia di trattamento dei dati personali da parte del Cliente;  
5) il Cliente, in relazione agli ambiti di trattamenti indicati alle lett. b) e c) che precedono, garantisce al Titolare di possedere l'esperienza, le competenze tecniche, l'affidabilità, le capacità e la struttura organizzativa idonee a garantire il lecito utilizzo dei Dati e ha confermato garanzie sufficienti circa l'adozione di misure tecniche e organizzative adeguate affinché il Trattamento soddisfi i requisiti della normativa vigente e garantisca la tutela dei diritti degli interessati;  
6) con la presente nomina, in conformità alle norme dell'ordinamento italiano e alla normativa sulla protezione dei dati personali in vigore, il Titolare intende attribuire al Cliente la qualifica di responsabile del trattamento ai sensi dell'art. 28 del Reg. (UE) 679/2016 e il Cliente manifesta la propria disponibilità ad assolvere l'incarico sopra indicato ai sensi della normativa sulla protezione dei dati personali.  
   

Tutto quanto sopra premesso, il Titolare, come identificato,

**NOMINA**

**il Cliente, come identificato nelle premesse,** **quale Responsabile (esterno) del trattamento dei dati effettuato tramite la Piattaforma, per le attività e con riferimento ai Dati di cui alle lett. b) e c) delle premesse** (di seguito "Responsabile" e congiuntamente al Titolare "Parti").

**1. Oggetto e durata della nomina**  
1.1. La presente nomina stabilisce le condizioni generali e le regole che devono essere rispettate dal Responsabile con riferimento al Trattamento dei Dati.  
1.2. Il Responsabile è autorizzato a procedere ad organizzare ogni operazione di Trattamento di Dati nel pieno rispetto delle norme previste dal Reg. (UE) 2016/679.  
1.3. La presente nomina ha efficacia dalla data della sua accettazione da parte del Responsabile e rimarrà in vigore finché il Contratto avrà efficacia tra le Parti. Alla cessazione, per qualsiasi causa, del Contratto, la presente nomina dovrà intendersi risolta. Resta inteso comunque che il Titolare può, in qualsiasi momento e senza preavviso alcuno, revocare la nomina al Responsabile.

**2. Obblighi del Responsabile**   
2.1. Il Responsabile ha il compito e la responsabilità di adempiere a tutto quanto necessario per il rispetto delle disposizioni vigenti in materia di protezione dei dati personali e di osservare scrupolosamente quanto in esse previsto, nonché le istruzioni impartite di volta in volta dal Titolare aventi ad oggetto il Trattamento dei Dati.   
2.2. Il Responsabile è tenuto a individuare, tra il proprio personale, e a nominare per iscritto le persone autorizzate al trattamento sotto l'autorità diretta del Responsabile ai sensi delle disposizioni della normativa sulla protezione dei dati personali, prescrivendo che essi abbiano accesso ai soli Dati la cui conoscenza sia necessaria per adempiere ai compiti assegnati.  
2.3. Il Responsabile si impegna a fornire per iscritto alle persone autorizzate al Trattamento, istruzioni in merito alle operazioni di Trattamento dei Dati, organizzando la loro attività, vigilando sull'osservanza delle norme e delle istruzioni impartite.   
2.4. Il Responsabile garantisce la riservatezza dei Dati durante il Trattamento.  
2.5. Il Responsabile si rende disponibile a mettere a disposizione del Titolare, su richiesta scritta e motivata di quest'ultimo, le informazioni necessarie per soddisfare i diritti di controllo del Titolare medesimo relativamente al Trattamento dei Dati.  
2.6. Ove previsto per legge, il Responsabile è tenuto a predisporre, per iscritto anche in formato elettronico, il registro delle attività di trattamento da esibire in caso di ispezione delle autorità competenti.  
2.7. Il Responsabile si impegna a non utilizzare i Dati per scopi diversi dal Trattamento.  
2.8. Il Responsabile garantisce il rispetto degli obblighi di cui agli artt. da 32 a 36 del Reg. (UE) 2016/679 - relativi alla sicurezza, alla notifica di violazioni, alle valutazioni d'impatto e alla consultazione con le autorità di controllo - tenendo conto della natura del Trattamento e delle informazioni disponibili per il Responsabile.  
2.9. Il Responsabile si impegna a portare a conoscenza degli interessati le informazioni di cui agli artt. 13 e 14 del Reg. (UE) 679/2016.  
2.10. Il Responsabile non determina le finalità e i mezzi del Trattamento.

**3. Altri responsabili del trattamento**  
3.1. Il Responsabile, nel rispetto delle condizioni di cui all'art. 28, par. 2 e 4, del Reg. (UE) 2016/679, si impegna a nominare altri responsabili solo previa specifica autorizzazione scritta del Titolare e dopo un'attenta valutazione dell'esperienza, delle competenze tecniche, dell'affidabilità, delle capacità, della struttura organizzativa idonee per le finalità e le modalità di trattamento e per garantire la predisposizione di misure tecniche e organizzative tese a salvaguardare la riservatezza, la completezza e l'integrità dei dati trattati, o comunque quelle più adatte a garantire il rispetto delle disposizioni vigenti della normativa sulla protezione dei dati personali. Il Responsabile si impegna, inoltre, a imporre agli altri responsabili nominati a mente del presente articolo, mediante un contratto o altro atto giuridico vincolante per l'ordinamento vigente, gli stessi obblighi in materia di protezione dei dati contenuti nel presente atto di nomina.

**4. Garanzie del Responsabile**  
4.1. Il Responsabile garantisce al Titolare la legittimità, correttezza, regolarità formale e sostanziale, nonché conformità - alle disposizioni *pro tempore* vigenti in materia di protezione e trattamento dei dati personali - delle forme e modalità di raccolta, trasferimento e messa a disposizione dei Dati.  
4.2. Per quanto precede, il Responsabile si impegna a tenere indenne e manlevato il Titolare da pretese, azioni, contestazioni avanzate da interessati e/o terzi a qualsiasi titolo per danni derivanti dalla violazione degli obblighi di cui alla presente nomina.

**5. Diritti di controllo del Titolare**  
Il Titolare potrà effettuare controlli per verificare la conformità delle misure tecniche e organizzative poste in essere dal Responsabile.

**6. Correzione, blocco, cancellazione dei Dati**  
Il Responsabile potrà correggere, cancellare o bloccare i Dati trattati solo su indicazione di quest'ultimo. Se un interessato dovesse rivolgersi direttamente al Responsabile con tale richiesta, il Responsabile inoltrerà senza indugio la richiesta al Titolare.

**7. Disposizioni finali**  
7.1. Per tutto quanto non espressamente previsto nella presente nomina, si rinvia alle disposizioni generali vigenti in materia di protezione dei dati personali.   
7.2. La presente nomina sarà regolata dalla legge italiana. Tutte le controversie che dovessero insorgere in relazione al contenuto del presente atto di nomina - comprese quelle inerenti alla sua validità, efficacia e interpretazione - saranno devolute alla competenza esclusiva del Foro di Brescia.  
7.3. Resta inteso che nessun compenso o remunerazione a qualsiasi titolo sono dovuti al Responsabile in ragione della presente nomina. 

***

Il Responsabile del trattamento, preso atto di quanto sopra, dichiara di accettare l'incarico, confermando la diretta e approfondita conoscenza degli obblighi che si assume in relazione alla normativa sulla protezione dei dati personali.
`,
    },
  },
  Groups: {
    weeks_duration: "Durata in settimane",
    activate_training_plan: "Piano di allenamento attivo",
    activate_training_plan_success:
      "Piano di allenamento attivato con successo",
    deactivate_training_plan: "Disattiva piano di allenamento",
    deactivate_training_plan_success:
      "Piano di allenamento disattivato con successo",
    send_notification: "Invia notifica",
    active_plan: "Piano attivo",
    inactive_plan: "Piano non attivo",
    activate_plan_to_notify: "Attiva il piano per inviare notifiche",
    notification_sent: "Notificato",
    notify_training_plan: "Notifica piano di allenamento",
    notify_training_plan_success:
      "Notifica piano di allenamento inviata con successo",
    create_training_plan: "Crea piano di allenamento",
    assigned_training_plans: "Piani di allenamento assegnati",
    generate_code_title: "Sei sicuro di voler rigenerare il codice invito?",
    generate_code_subtitle: "Il codice precedente non sarà più valido",
    generate_new_code: "Genera nuovo codice",
    participants: "Partecipanti",
    add_assignment: "Aggiungi Assegnazione",
    remove_assignment: "Rimuovi Assegnazione",
    edit_assignment: "Modifica Assegnazione",
    add_assignment_success: "Assegnazione creata con successo",
    remove_assignment_success: "Assegnazione rimossa con successo",
    edit_assignment_success: "Assegnazione modificata con successo",
    label_empty_assigned_video_list: "Nessun video assegnato",
    label_empty_playlist_list: "Nessuna playlist assegnata",
    no_expiration: "Nessuna scadenza",
    expired: "Scaduto",
    remove_assign_label: "Vuoi rimuovere l'assegnazione da questo gruppo?",
    remove_user_from_group: "Vuoi rimuovere il cliente dal gruppo?",
    missing_days: "Scade tra {{count}} giorni",
    active_from: "Attivo dal",
    weeks: "{{ count }} settimane",
    months: "{{ count }} mesi",
    duration: "Durata",
    choose_customer: "Scegli cliente",
    invite_customers: "Invita Clienti",
    invite_button: "Invita",
    add_customers: "Aggiungi Membri",
    add_button: "Aggiungi",
    no_customers_to_add: "Nessun cliente da aggiungere",
    group_members: "Partecipanti del gruppo",
    add_member_success: "Membro aggiunto con successo",
    remove_member_success: "Membro rimosso con successo",
    delete_groups: "Elimina gruppi",
    delete_groups_success: "Gruppi eliminati con successo",
    error_groups: "Errore Gruppi",
    error_groups_settings: "Errore Impostazioni Gruppi",
    error_groups_subtitle: "Errore gruppi",
    error_group_subtitle: "Impossibile caricare i dati del gruppo",
    error_group_members_subtitle: "Lista membri gruppo non caricata",
    error_group_manage_members_subtitle:
      "Aggiunta/rimozione membro non riuscita",
    error_create_group: "Nuovo gruppo non creato",
    error_edit_group: "Gruppo non modificato",
    error_delete_group: "Gruppo non eliminato",
    error_delete_groups: "Gruppi non eliminati",
    delete_groups_title: "Vuoi eliminare questi gruppi?",
    delete_group_title: "Vuoi eliminare questo gruppo?",
    delete_groups_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> i seguenti gruppi dalla lista.",
    delete_group_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente gruppo dalla lista.",
    total_count: "clienti",
    active_count: "attivi",
    edit: "Modifica",
    video_list: "Lista video assegnati",
    playlists_list: "Lista playlists assegnate",
    training_deadline: "Scadenza allenamento",
    list: "Lista gruppi",
    add_group: "Aggiungi gruppo",
    label_selected: "selezionati",
    copy_email: "Copia email",
    delete_training_plan_title: "Vuoi eliminare questo piano di allenamento?",
    delete_training_plan_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente piano di allenamento dalla lista.",
    select_all_button_one: `Seleziona il gruppo esistente`,
    select_all_button_other: `Seleziona tutti i {{count}} gruppi esistenti`,
    select_all_one: `Hai selezionato {{count}} gruppo.`,
    select_all_other: `Hai selezionato {{count}} gruppi.`,
    list_customer_one: `{{count}} cliente`,
    list_customer_other: `{{count}} clienti`,
    select_all_total: `Tutti i {{count}} gruppi sono stati selezionati`,
    cancel_all: `Annulla selezione`,
    group_name: "Nome gruppo",
    generate: "Genera",
    copy: "Copia",
    invite_code: "Codice invito",
    invite_description:
      "Condividi questo codice invito con i tuoi nuovi clienti per collegarli al tuo account REVOO. Con questo codice i clienti, terminata la registrazione, visualizzeranno tutti i materiali allegati (piani di allenamento, video, playlist)",
    delete: "Elimina",
    new_group: "Nuovo gruppo",
    edit_group: "Modifica gruppo",
    photo: "Foto",
    name: "Nome",
    create_group: "Crea gruppo",
    create_group_success: "Gruppo creato con successo",
    edit_group_success: "Gruppo modificato con successo",
    warning_emails: "Email gruppi",
    warning_emails_subtitle: "Non ci sono email associate a questi gruppi",
    tabs: {
      members: "Membri",
      training_plans: "Allenamenti",
      nutrition_plans: "Nutrizione",
      media: "Media",
      settings: "Impostazioni",
      mobile_section_caption: "Sezione",
    },
    settings: {
      title: "Impostazioni gruppo",
      success: "Impostazioni gruppo salvate con successo",
      assign_all_clients: "Assegna tutti i tuoi clienti a questo gruppo",
      enable_chat_for_new_members: "Attiva Chat per i nuovi membri del gruppo",
      automate_client_removal:
        "Automatizza la rimozione dei clienti dal gruppo",
      save_automations: "Salva automazioni",
      after: "Dopo",
      from_their_entrance: "dal loro ingresso",
      rule_interval: {
        day: "Giorni",
        week: "Settimane",
        month: "Mesi",
        year: "Anni",
      },
      in_date: "In data",
      alert: {
        activate_title:
          "Sei sicuro di voler assegnare tutti i tuoi clienti attuali e futuri a questo gruppo? (Eventuali automazioni di rimozione dal gruppo saranno rimosse)",
        deactivate_title:
          "Tutti i tuoi clienti saranno rimossi da questo gruppo. Sei sicuro di voler proseguire?",
      },
    },
  },
  InviteCustomer: {
    title: "Invita nuovi clienti",
    description:
      "Condividi questo codice invito con il tuo nuovo cliente per collegarlo al tuo account REVOO.",
    code: "Codice invito",
    changeCode: "Vuoi cambiare il tuo codice referral?",
    changeCodeDescription:
      "Rigenera il tuo codice invito e invia quello precedente verrà disabilitato",
    changeCodeButton: "Genera nuovo",
    copied: "Copiato",
    copy: "Copia",
  },
  Login: {
    title: `Accedi a ${appName}`,
    title_mobile: "Accedi a REVOO PT",
    subtitle_mobile: "L'app per i personal trainer",
    email: "La tua email*",
    password: "Password*",
    login: "Accedi",
    error: "Le credenziali sono errate",
    error_not_pt: "Impossibile eseguire l'accesso",
    error_not_pt_subtitle:
      "Usa le tue credenziali per accedere all'app di allenamento sul tuo telefono.",
    register: "Registrati",
    dont_have_an_account: "Non hai un account?",
  },
  Migration: {
    success: "Migrazione completata con successo!",
    failed: "Migrazione fallita.",
    already_migrated: "Il tuo account è già stato migrato.",
    error_migration: "Errore Migrazione",
    error_migration_subtitle: "Migrazione non completata",
    migration_completed: "Migrazione Completata",
    migration_completed_success: "Migrazione completata con successo",
    invalid_token: "Token non valido.",
  },
  Checkout: {
    back_to_app: "Clicca su X per tornare all'app",
    purchase_error: "Si è verificato un errore in fase di acquisto",
  },
  Nutrition: {
    add_nutrition_plan: "Aggiungi piano nutrizionale",
    create_nutrition_plan: "Crea piano nutrizionale",
    foods: "Alimenti",
    addFood: "Aggiungi alimento",
    tabs: {
      plans: "Piani nutrizionali",
      assigned_plans: "Piani nutrizionali assegnati",
    },
    table: {
      columns: {
        name: "Piano nutrizionale",
        energy: "Energia",
        weekly_average: "Media settimanale",
        proteins: "Proteine",
        carbohydrates: "Carboidrati",
        fats: "Grassi",
        days: "Giorni",
      },
      filters: {
        all: "Tutti",
        assigned: "Personali",
        base_library: "Libreria Base",
      },
    },
    foodsTable: {
      columns: {
        name: "Nome",
        energy: "Energia",
        proteins: "Proteine",
        carbohydrates: "Carboidrati",
        fats: "Grassi",
      },
    },
    foodsDeleteModal: {
      title_one: "Vuoi eliminare l'alimento selezionato?",
      title_other: "Vuoi eliminare gli alimenti selezionati?",
      subtitle_one:
        "Procedendo <strong>eliminerai definitivamente</strong><br /> questo elemento dalla lista.",
      subtitle_other:
        "Procedendo <strong>eliminerai definitivamente</strong><br /> gli elementi selezionati dalla lista.",
    },
    assign_plan: "Assegna Piano",
    plansDeleteModal: {
      title_one: "Vuoi eliminare il piano selezionato?",
      title_other: "Vuoi eliminare i piani selezionati?",
      subtitle_one:
        "Procedendo <strong>eliminerai definitivamente</strong><br /> questo piano dalla lista.",
      subtitle_other:
        "Procedendo <strong>eliminerai definitivamente</strong><br /> i piani selezionati dalla lista.",
    },
  },
  Menu: {
    nutrition: "Nutrizione",
    settings: "Impostazioni",
    dashboard: "Dashboard",
    customers: "Clienti",
    groups: "Gruppi",
    workouts: "Allenamenti",
    video: "Video",
    meetings: "Appuntamenti",
    form: "Form",
    calendar: "Calendario",
    activities: "Attività",
    chat: "Chat",
    vods: "Video On Demand",
    notifications: "Notifiche",
    products: "Prodotti",
    team: "Team",
    surveys: "Questionari",
  },
  Models: {
    name: "Nome modello",
    cards: "Schede",
    duration: "Durata",
    level: "Livello",
    duplicate: "Copia Modello",
    levels: {
      beginner: "Principiante",
      intermediate: "Intermedio",
      advanced: "Avanzato",
      elementary: "Elementare",
    },
    deleteModal: {
      title_one: "Vuoi eliminare il modello selezionato?",
      title_other: "Vuoi eliminare i modelli selezionati?",
      subtitle_one:
        "Procedendo <strong>eliminerai</strong> il modello dalla lista.",
      subtitle_other:
        "Procedendo <strong>eliminerai</strong> i modelli selezionati.",
    },
    forms: {
      assignTitle: "Assegna modello",
      createTitle: "Crea modello",
      editTitle: "Modifica modello",
      editPlans: "Modifica piano",
      customers: "Cliente",
      groups: "Gruppo",
      name: "Modello",
      image: "Foto copertina",
      date_of_start: "Data di inizio",
      weeks_duration: "Durata in settimane",
      level: "Livello",
      simplifiedVisualization: "Visualizzazione semplificata",
      note: "Note",
      assign: "Assegna",
    },
  },
  Notifications: {
    list: "Lista notifiche",
    add_notification: "Aggiungi notifica",
    success_notification_subtitle: "Nuova notifica creata con successo",
    edit_notification: "Modifica notifica",
    edit_notification_success: "Notifica modificata con successo",
    clone_notification: "Duplica notifica",
    success_clone_notification: "Notifica duplicata con successo",
    delete_notification: "Elimina notifica",
    delete_notification_confirm:
      "Sei sicuro di voler eliminare la notifica {{name}}?",
    delete_notification_success: "Notifica eliminata con successo",
    error_notifications: "Errore Notifiche",
    error_notifications_subtitle: "Lista notifiche non caricata",
    error_notification_subtitle: "Nuova notifica non creata",
    error_notification_label: "Operazione su notifica non riuscita",
    form_creation_title: "Crea notifica - Passo {{index}} di {{total}}",
    form_creation_title_simple: "Crea Notifica",
    form_clone_title: "Clona notifica - Passo {{index}} di {{total}}",
    form_edit_title: "Modifica notifica - Passo {{index}} di {{total}}",
    alert_confirm_button:
      "Proseguendo la notifica verrà inviata nuovamente. Sei sicuro di voler procedere?",
    form: {
      name: "Nome interno della notifica",
      title: "Titolo notifica",
      title_max: "Il titolo è troppo lungo: massimo 255 caratteri.",
      subtitle: "Sottotitolo notifica",
      subtitle_max: "Il sottotitolo è troppo lungo: massimo 240 caratteri.",
      subtitle_readability_hint:
        "Oltre ~150 caratteri il testo potrebbe essere troncato sullo schermo di blocco.",
      preview: "Anteprima notifica",
      target_type: "Destinatari",
      customers: "Clienti",
      groups: "Gruppi",
      periodicity_type: "Programmazione",
      periodicity_send_at: "Data di invio",
      periodicity_send_from: "Data di inizio invio",
      periodicity_send_to: "Data di fine invio",
      periodicity_time: "Ora di invio",
      periodicity_frequency: "Frequenza",
      submit: "Salva",
      prev: "Indietro",
      next: "Avanti",
    },
    headers: {
      notification_name: "Titolo",
      target_type: "Destinatari",
      sent_at: "Data di invio",
      status: "Stato",
      actions: "Azioni",
    },
    actions: {
      edit: "Modifica",
      clone: "Duplica",
      delete: "Elimina",
    },
    periodicity_types: {
      instant: "Invio immediato",
      scheduled: "Programmato",
      recurring: "Ricorrente",
    },
    target_types: {
      all: "Tutti i clienti",
      customers: "Clienti selezionati",
      groups: "Gruppi selezionati",
    },
    frequency_types: {
      daily: "Giornaliera",
      weekly: "Settimanale",
      monthly: "Mensile",
    },
    statuses: {
      pending: "In attesa",
      scheduled: "In programmazione",
      sending: "Invio in corso",
      canceled: "Cancellata",
      sent: "Inviata",
      completed: "Inviata",
    },
  },
  Products: {
    label_empty_table: "Nessuna transazione presente",
    delete: {
      title: "Vuoi eliminare <br />il prodotto selezionato?",
      description: "Procedendo <strong>lo perderai</strong> definitivamente",
    },
    form: {
      product_includes: "Il prodotto include: ",
      name: "Nome Prodotto",
      short_description: "Descrizione breve",
      description: "Descrizione",
      payment_type: "Tipo di pagamento",
      price: "Prezzo finale",
      at_groups: "Assegna ai gruppi",
      original_price: "Prezzo barrato",
      thank_you_message: "Messaggio di ringraziamento",
      url_after_purchase: "Link post-acquisto",
      payment_type_option: {
        subscription: "Abbonamento",
        one_time: "Acquisto unico",
      },
      price_option: "Ogni",
      price_options: {
        month: "Mese",
        six_weeks: "Sei settimane",
        three_months: "Tre mesi",
        six_months: "Sei mesi",
        year: "Anno",
      },
      tooltip:
        'Se decidi di offrire il prodotto ad un prezzo scontato puoi inserire qui il suo prezzo originale; verrà mostrato nell\'app "barrato" per aumentare le conversioni. Attenzione, questo non è il prezzo finale di vendita!',
    },
    no_operations:
      "Non puoi effettuare operazioni mentre un prodotto è in revisione.",
    table: {
      column: {
        date: "Data",
        customer: "Cliente",
        description: "Descrizione",
        amount: "Importo",
        product: "Prodotto",
      },
    },
    error: {
      get_transactions_title: "Errore Transazioni",
      get_transactions_subtitle: "Transazioni non caricate",
      get_product_title: "Errore Prodotto",
      get_product_subtitle: "Prodotto non caricato",
      create_product_title: "Errore Prodotto",
      create_product_subtitle: "Prodotto non creato",
      update_product_title: "Errore Prodotto",
      update_product_subtitle: "Prodotto non aggiornato",
      delete_product_title: "Errore Prodotto",
      delete_product_subtitle: "Prodotto non eliminato",
      notify_product_title: "Errore Prodotto",
      notify_product_subtitle: "Prodotto non notificato",
      export_transactions_title: "Errore esportazione transazioni",
      export_transactions_subtitle: "Transazioni non esportate",
      export_transactions_loading: "Esportazione in corso",
      fetch_transactions_title: "Errore aggiornamento transazioni",
      fetch_transactions_subtitle: "Transazioni non aggiornate",
    },
    success: {
      create_product_title: "Prodotto creato",
      create_product_subtitle: "Prodotto creato con successo",
      update_product_title: "Prodotto aggiornato",
      update_product_subtitle: "Prodotto aggiornato con successo",
      delete_product_title: "Prodotto eliminato",
      delete_product_subtitle: "Prodotto eliminato con successo",
      notify_product_title: "Prodotto notificato",
      notify_product_subtitle: "Prodotto notificato con successo",
      export_transactions_title: "Transazioni esportate",
      export_transactions_subtitle: "Transazioni esportate con successo",
      fetch_transactions_title: "Transazioni aggiornate",
      fetch_transactions_subtitle: "Transazioni aggiornate con successo",
    },
    tabs: {
      products: "Prodotti",
      transactions: "Transazioni",
    },
    buttons: {
      add_product: "Aggiungi prodotto",
    },
    edit_product: "Modifica prodotto",
    new_product: "Nuovo prodotto",
    no_data: "Nessun prodotto presente",
    rank: "Rank",
    product: "Prodotto",
    price: "Prezzo",
    status: "Status",
    status_enum: {
      under_review: "In revisione",
      approved: "Approvato",
      failed: "Bocciato",
    },
    revoo_pay: {
      no_account: "Nessun account",
      title: "Connetti il tuo account REVOO a Stripe",
      connect: "Connetti",
      disabled: {
        title:
          "Vendi i tuoi percorsi di allenamento in modo semplice e automatico.",
        description_1:
          "Con REVOO Pay i tuoi clienti possono acquistare direttamente dall'app i tuoi percorsi (schede di allenamento e/o video on-demand).",
        description_2:
          "Tu crei i prodotti dalla piattaforma e REVOO si occupa di tutto il resto: pagamenti, conferme e attivazione immediata dei percorsi.",
        discover:
          "👉 Scopri tutte le funzionalità nel documento completo - <button1><text>clicca qui</text></button1>.",
        app_required:
          "Per attivare REVOO Pay è necessaria l'App Personalizzata.",
        request_revoo_pay: "Richiedi REVOO Pay",
        request_custom_app: "Richiedi app personalizzata",
      },
    },
  },
  Profile: {
    settings: "Impostazioni profilo",
    guide: "Guida",
    webinar_request: "Richiedi Webinar",
    products: "Prodotti",
    guides_and_tutorials: "Guide e Tutorial",
    logout: "Esci",
  },
  RecoverPassword: {
    recover_password: "Recupera password",
    insert_email:
      "Inserisci l'email con cui ti sei registrato per recuperare la password.",
    email_sent: "Ti abbiamo inviato una email per recuperare la password.",
    back_to_login: "Torna al login",
    reset_password: "Reimposta password",
    reset_password_subtitle: "Password impostata con successo.",
  },
  ResetPassword: {
    title: "Reimposta password",
    missing_token_title: "Token mancante",
    missing_token_subtitle:
      "Il link di reset password non è valido. Controlla la tua email o richiedi un nuovo link.",
    not_found_title: "Token non valido",
    not_found_subtitle:
      "Il token di reset password non è valido o è scaduto. Richiedi un nuovo link di reset.",
    generic_error_title: "Errore",
    generic_error_subtitle:
      "Si è verificato un errore durante il caricamento. Riprova più tardi.",
    back_to_recover: "Torna al recupero password",
    success_title: "Password reimpostata con successo",
    success_subtitle: "Ora puoi procedere sull'app",
  },
  Services: {
    button_label: "Servizi per te",
    title: "Servizi REVOO",
    partner_prozis: "Diventa partner Prozis",
    invite_friend: "Porta un amico",
    site_web: "Crea il tuo sito web",
    create_app: "Crea la tua app",
  },
  Settings: {
    billing_upgrade_now: "Aggiorna ora",
    billing_message_title:
      "<strong>⚠️ Aggiorna i tuoi dati di pagamento</strong>",
    billing_message:
      "Stiamo passando a un nuovo sistema di pagamento più sicuro e veloce. Per continuare a usare la piattaforma senza interruzioni, ti chiediamo di aggiornare <strong>ora</strong> i tuoi dati di <strong>pagamento</strong> e <strong>fatturazione</strong>.<br><br>" +
      "🔒 L'operazione richiede pochi minuti ed è completamente sicura.<br>",
    error: {
      personal_informations: {
        update_settings_title: "Errore aggiornamento impostazioni",
        update_settings_subtitle: "Impostazioni non aggiornate",
      },
      password: {
        update_settings_title: "Errore aggiornamento impostazioni",
        update_settings_subtitle: "Impostazioni non aggiornate",
      },
      get_settings_title: "Errore impostazioni",
      get_settings_subtitle: "Impostazioni non caricate",
      update_settings_title: "Errore aggiornamento impostazioni",
      update_settings_subtitle: "Impostazioni non aggiornate",
    },
    success: {
      update_subscription_title: "Abbonamento aggiornato",
      update_subscription_subtitle: "Abbonamento aggiornato con successo",
      personal_informations: {
        update_settings_title: "Impostazioni aggiornate",
        update_settings_subtitle: "Impostazioni aggiornate con successo",
      },
      password: {
        update_settings_title: "Impostazioni aggiornate",
        update_settings_subtitle: "Impostazioni aggiornate con successo",
      },
      update_settings_title: "Impostazioni aggiornate",
      update_settings_subtitle: "Impostazioni aggiornate con successo",
    },
    billing: {
      support_title:
        "Non vedi le tue fatture? Non preoccuparti, te le inviamo noi! 😉",
      support_subtitle:
        "Le fatture sono inviate automaticamente al tuo indirizzo email.<br />Per qualsiasi necessità scrivici in chat oppure scrivi a <strong>fatture@revoo-app.com</strong",
      subscription: {
        error: {
          trial_ended: "Il periodo di prova è terminato.",
        },
        loading: "Caricamento...",
        loading_portal: "Caricamento portale cliente...",
        title: "Il tuo abbonamento",
        detail_plan: "Dettaglio piano",
        update_payment_method: "Aggiorna metodo di pagamento",
        status: {
          active: "Attivo",
          trialing: "Trial",
          unpaid: "Non pagato",
          past_due: "Scaduto",
          no_subscription: "Cancellato",
          canceled: "Cancellato",
        },
        price_interval: {
          month: "Al mese",
          year: "All'anno",
        },
        active_customers: "Clienti attivi",
        alert: {
          title: "Attenzione!",
          subtitle:
            "Hai superato il limite consentito dal tuo abbonamento, per continuare ad utilizzare REVOO aggiorna il tuo piano.",
          invite_title:
            "Hai raggiunto il limite di inviti consentito dal tuo abbonamento.",
        },
        messages: {
          trial_ends_at: "Il periodo di prova termina tra {{days}} giorni.",
          trial_ended:
            "Il periodo di prova è terminato! Per continuare aggiorna i dati.",
          trial_ended_choose_plan:
            "Il periodo di prova è terminato! Scegli un piano per continuare.",
          trial_ends_today:
            "Il periodo di prova termina oggi. Scegli un piano per continuare.",
          no_subscription:
            "Non hai nessun abbonamento attivo. Clicca su Abbonati per continuare.",
          trial_ends_new_plan_starts_at:
            "Stai continuando ad usare il periodo di prova gratuita. Il nuovo piano si attiverà il {{ date }}.",
          trial_warning:
            "Se al termine del periodo di prova ci saranno più Clienti attivi o Video On Demand di quanti consentiti dal piano che hai scelto, ti verrà chiesto di effettuare un upgrade per continuare ad utilizzare REVOO.",
          plan_renews_at:
            "Il piano si rinnova automaticamente in data {{ date }}.",
          plan_renews_at_downgrade:
            "Questo piano terminerà in data {{ date }} e sarà sostituito dal piano {{ plan }}.",
          payment_problem:
            "Problema nel pagamento, clicca qui per aggiornare i dati della tua carta.",
          browser_problem:
            "Problema nel pagamento, vai sul sito <button1><text>train.revoo-app.com</text></button1> per aggiornare i dati della tua carta",
          click_on_subscribe:
            "Clicca su Abbonati per far ripartire il tuo abbonamento.",
          plan_will_not_renew:
            "Il tuo piano verrà annullato come richiesto, ma resterà disponibile fino al termine della prova gratuita il giorno {{ date }}.",
          plan_will_not_renew_until:
            "Il tuo piano verrà annullato come richiesto, ma resterà disponibile fino al giorno {{ date }}.",
          plan_will_not_renew_subtitle:
            "Se cambi idea puoi <button1><text>rinnovarlo</text></button1> oppure <button2><text>scegliere un nuovo piano</text></button2>.",
          plan_will_be_canceled_at:
            "Il piano verrà cancellato in data {{ date }}. Se vuoi annullare la cancellazione del piano <button1><text> clicca qui</text></button1>.",
          back_to_old:
            "Vuoi utilizzare la versione precedente di REVOO? <button1><text>Clicca qui</text></button1>.",
          plan_canceled: "Il piano è stato cancellato .",
          plan_canceled_at: "Il piano è stato cancellato in data {{ date }}.",
          payment_error:
            "Pagamento non riuscito: verifica di avere fondi sufficienti o <button1><text>clicca qui</text></button1> per aggiornare il metodo di pagamento.",
          paddle_migration_action_required:
            "Aggiornamento del sistema di pagamento.<br>" +
            "Ti chiediamo di aggiornare i tuoi dati: l'operazione è semplice e non comporterà alcun addebito.",
        },
        buttons: {
          more_info: "Maggiori informazioni",
          subscribe: "Abbonati",
          payment_data: "Aggiorna pagamento",
          change_plan: "Cambia piano",
          update_payment_data: "Aggiorna dati pagamento",
        },
      },
      billing_details: {
        no_data: "Nessun dato inserito",
        title: "Dati fatturazione",
        type: {
          company: "Azienda",
          person: "Persona Fisica",
        },
        vat_number: "P.IVA {{value}}",
        tax_code: "Codice Fiscale {{value}}",
        form: {
          title: "Modifica dati fatturazione",
          type: "Tipologia",
          vat_number: "Partita IVA",
          tax_code: "Codice Fiscale",
          address_street: "Indirizzo",
          address_postal_code: "CAP",
          address_city: "Città",
          address_province: "Provincia",
          country: "Paese",
          name: "Nome completo o ragione sociale",
          first_name: "Nome",
          last_name: "Cognome",
          pec: "PEC",
          ei_code: "Codice Univoco",
          address_street_placeholder: "Inserisci indirizzo completo...",
        },
      },
      payment_method: {
        title: "Metodo di pagamento",
        name: "Nome Intestatario",
        no_data: "Nessun metodo di pagamento inserito",
      },
      change_plan: {
        title: "Piani abbonamento",
        filters: {
          all: "Tutti",
          up_to_50: "Fino a 50 clienti",
          up_to_300: "Fino a 300 clienti",
          unlimited: "Illimitati",
        },
        switch: {
          monthly: "Mensile",
          yearly: "Annuale",
        },
        subtitle: "Scegli un nuovo piano mensile o annuale.",
        choose_this_plan: "Scegli questo piano",
        current_plan: "Piano attuale",
        previous_plan: "Piano precedente",
        most_popular: "Più popolare",
        at_month: "al mese",
        at_year: "all'anno",
        start_your_path: "Inizia il tuo percorso REVOO",
        excluded_feature:
          "REVOO pay  e personalizzazione app <br><strong>sono escluse</strong>",
        features: {
          up_to_value_customers: "Fino a {{ customers }} clienti",
          up_to_value_vods: "{{ vods }} video on demand",
          unlimited_customers: "Clienti illimitati",
          unlimited_vods: "Video illimitati",
          customers_groups: "Gruppi clienti",
          automations: "Automazioni",
          vods: "Video on demand",
          chat: "Chat",
        },
        contact_us: "Contattaci",
        change_plan: "Cambia piano",
        confirm_and_pay: "Conferma e procedi al pagamento",
        change_plan_confirm_subtitle:
          "Controlla i tuoi dati e concludi il tuo abbonamento",
        change_plan_migration:
          "Controlla i tuoi dati e aggiorna il tuo abbonamento. Aggiornando i dati non verrà effettuato nessun addebito.",
        new_plan_selected: "Nuovo piano selezionato",
        automatic_renew_at:
          "Il piano si rinnova automaticamente in data {{ date }}",
        upgrade_message:
          "L'addebito odierno sarà di {{ amount }} {{ currency }}",
        downgrade_message:
          "Il nuovo piano si attiverà immediatamente. Non pagherai nulla adesso.",
        edit_payment_method: "Modifica dati pagamento",
        contact_support:
          "Momentaneamente non è possibile effettuare questa operazione. Contatta il supporto per effettuare modifiche al piano.",
      },
      next_payment: {
        included_vat: "iva inclusa",
        estimate_next_payment: "Stima prossimo addebito",
        description: "Descrizione",
        quantity: "Quantità",
        amount: "Importo",
        total: "Totale",
        residual_credit_applied: "Credito residuo applicato",
        amount_due: "Importo dovuto",
        tooltip:
          "Il valore indicato è comprensivo di IVA al 22% se dovuta e sarà reso esplicito in sede di emissione fattura.",
      },
    },
    "legal-&-compliance": {
      terms_and_conditions: "Termini e condizioni",
      privacy_policy: "Privacy policy",
      appointment_for_data_processing: "Nomina al trattamento dei dati",
    },
    profile: {
      coaching: "Coaching",
      social: "Social",
      contact_data: "Dati di contatto",
      business_nickname: "Business Nickname",
      image: "Scegli la tua foto profilo",
      bio: "Bio",
      email: "Email",
      phone: "Telefono",
      show_phone_number: "Mostra numero di telefono in app cliente",
      instagram: "Instagram",
      facebook: "Facebook",
      online: "Coaching online",
      live: "Coaching diretto con il cliente",
    },
    preferences: {
      chat: "Chat",
      active_chat: "Attiva chat per i nuovi clienti",
      workouts: "Allenamenti",
      show_future_workouts:
        "Mostra ai clienti i piani assegnati con data futura",
      language: "Lingua",
      select_language: "Seleziona lingua",
      languages: {
        it: "🇮🇹 Italiano",
        en: "🇬🇧 Inglese",
      },
    },
    referral: {
      your_referral_code: "Il tuo codice referral",
      bring_a_friend_title:
        "Se porti un amico in REVOO con il tuo referral-code",
      bring_a_friend_subtitle:
        "Tu hai diritto a 20 % di guadagno per 3 mesi sull'ammontare che il tuo amico spende su REVOO.",
      bring_a_friend_second_subtitle:
        "Il tuo amico ha diritto a 20 % di sconto per 3 mesi.",
      remaining_credit: "Credito residuo",
      remaining_credit_subtitle:
        "Questo è il credito guadagnato tramite codice sconto o referral code. Ti sarà stornato dalla prossima fattura",
    },
    personal_informations: {
      personal_data: "Dati anagrafici",
      name: "Nome",
      surname: "Cognome",
      date_of_birth: "Data di nascita",
      gender: "Sesso",
      country: "Paese",
      city: "Città",
    },
    password: {
      edit_your_password: "Modifica la tua password",
      new_password: "Nuova password",
      repeat_new_password: "Ripeti nuova password",
      actual_password: "Password attuale",
    },
    delete_account: {
      delete_account_title: "Elimina account",
      delete_account_subtitle:
        "<b>Attenzione</b>: prima di eliminare il tuo account devi annullare l’abbonamento attivo.<br />" +
        "<b>Finché l’abbonamento risulta attivo, l’eliminazione dell’account non può essere completata.</b><br />" +
        "Se hai un abbonamento attivo, <billingLink>clicca qui</billingLink>, poi seleziona “<b>Dettaglio piano</b>” e procedi alla cancellazione dell’abbonamento.<br />" +
        "Se invece ti trovi nel periodo di prova di 20 giorni, puoi chiedere direttamente l’eliminazione dell’account senza ulteriori passaggi.<br />" +
        "<b>Nota</b>: l’eliminazione viene confermata entro circa 7 giorni lavorativi.",
    },
    notifications: {
      title: "Puoi attivare o disattivare le singole notifiche",
      push_notifications: "Notifiche push",
      receive_notifications_when_pt: "Ricevi notifiche quando il PT",
      receive_notifications_when_customer: "Ricevi notifiche quando il cliente",
      crud_on_calendar: "Aggiunge, modifica, elimina evento a calendario",
      add_anamnesis: "Aggiunge anamnesi",
      add_progress_photo: "Aggiunge foto progressi",
      add_composition: "Aggiunge composizione corporea",
      add_circumference: "Aggiunge circonferenza",
      is_not_active: "Non è attivo",
      workout_plan_expiration: "Piano di allenamento in scadenza",
      complete_workout: "Completa allenamento",
      complete_workout_with_feedback: "Completa allenamento con feedback",
      buy_a_product: "Acquista un prodotto",
    },
    card: {
      profile: {
        title: "Profilo",
        description:
          "Gestisci il tuo profilo e le informazioni per farti contattare dai tuoi clienti",
      },
      "personal-informations": {
        title: "Informazioni personali",
        description: "Imposta i tuoi dati personali",
      },
      password: {
        title: "Password",
        description: "Aggiorna la tua password e proteggi il tuo account",
      },
      preferences: {
        title: "Preferenze",
        description: "Imposta la lingua e la chat con i tuoi clienti",
      },
      notifications: {
        title: "Notifiche",
        description: "Imposta le tue preferenze di notifica",
      },
      billing: {
        title: "Fatturazione",
        description:
          "Verifica i metodi di pagamento, le fatture e i prossimi rinnovi",
        next_payment: {
          title: "Prossimo addebito",
        },
      },
      referral: {
        title: "Codice referral",
        description:
          "Visualizza il tuo credito residuo e condividi il tuo codice",
      },
      "legal-&-compliance": {
        title: "Legal & Compliance",
        description:
          "Visualizza i termini e le condizioni, la privacy policy e la nomina al trattamento dei dati",
      },
      "delete-account": {
        title: "Elimina account",
        description: "Richiedi l'eliminazione del tuo account",
        message:
          "Per procedere, inserisci esattamente il nome della risorsa <strong>{{name}}</strong> per confermare. Questa operazione non può essere annullata.",
        confirmation_message:
          "La tua richiesta di eliminazione è stata registrata. Il tuo account sarà eliminato entro 15 giorni.",
        modal: {
          subtitle:
            "È in corso la cancellazione di questo account. Vuoi annullare la procedura?",
          confirm_button: "Annulla cancellazione",
        },
      },
    },
  },
  Signup: {
    title: `Registrati a ${appName}`,
    already_have_account: "Hai già un account?",
    dont_want_to_register: "Non vuoi registrarti?",
    login: "Accedi",
    register: "Registrati",
    next: "Avanti",
    back: "Indietro",
    insert_your_personal_data: "Inserisci i tuoi dati personali",
    insert_your_contact_data: "Inserisci i tuoi dati di contatto",
    set_your_profile: "Imposta il tuo profilo",
    no_payment_method: "Nessun metodo di pagamento richiesto",
    completed: "Registrazione completata!",
    start: "Iniziamo!",
    form: {
      email: "La tua email",
      password: "Password",
      referral_code: "Codice referral (facoltativo)",
      gdpr: "Accetto la Privacy Policy",
      terms: "Accetto i Termini e le Condizioni di utilizzo",
      marketing:
        "Acconsento al trattamento dei miei dati personali per ricevere offerte e promozioni da REVOO via email",
      name: "Nome",
      surname: "Cognome",
      birth_date: "Data di nascita",
      gender: "Sesso",
      country: "Paese",
      city: "Città",
      locality: "Località",
      phone_number: "Telefono",
      business_nickname: "Business Nickname",
      image: "Scegli la tua foto profilo",
    },
    error: {
      title: "Errore Registrazione",
      subtitle: "Registrazione non riuscita",
    },
  },
  Statistics: {
    activityState: {
      title: "Stato delle tue attività",
      customers: "Clienti",
      groups: "Gruppi",
      workouts: "Workout eseguiti ieri",
      videoViews: "Video visualizzati",
    },
    activeCustomers: {
      title: "Clienti attivi",
      activeCustomers: "Clienti attivi",
      columns: {
        workouts: "Workout svolti",
        customers: "Clienti",
        executedAt: "Eseguito il",
      },
      viewAll: "Vedi tutti",
    },
    workouts: {
      title: "Workout",
      filter: "Filtra per",
      checkbox: "Mostra solo i workout con feedback",
      columns: {
        customers: "Clienti",
        feedback: "Feedback",
        executedAt: "Eseguito il",
      },
      viewAll: "Vedi tutti",
    },
    mostViewedVideos: {
      title: "Video più visti",
      views: "Visualizzazioni",
      viewAll: "Vedi tutti",
    },
  },
  Surveys: {
    banner:
      "L'aggiornamento con i questionari personalizzati è in fase di rilascio sulla tua app personalizzata. Verifica che tutti i contratti siano aggiornati sul tuo Apple Developer Account",
    error_surveys: "Errore Questionari",
    error_surveys_create:
      "Un questionario con questo nome esiste già. Modifica per continuare.",
    add_survey: "Aggiungi questionario",
    compile_survey: "Compila questionario",
    tabs: {
      models: "Modelli",
    },
    submissions_count: "Numero invii",
    submissions: "Invii",
    model_name: "Nome modello questionario",
    create_survey: "Crea questionario",
    edit_survey: "Modifica questionario",
    assign_survey: "Assegna questionario",
    already_assigned: "Già assegnato",
    selected_label: "Selezionati: {{count}}",
    assigned_label: "Assegnati: {{count}}",
    delete_survey: "Elimina questionario",
    survey: "Questionario",
    created_by: "Creato da",
    filled_by: "Compilato da",
    submission_date: "Data di compilazione",
    submissions_list: "Lista delle compilazioni",
    see_results: "Vedi risultati",
    complete: "Completa",
    delete_survey_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente questionario dalla lista.",
    delete_submission: "Elimina compilazione",
    delete_submission_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> la seguente compilazione dalla lista.",
    label_selected: "Selezionati",
    unassign_survey: "Rimuovi questionario",
    unassign_survey_subtitle:
      "Procedendo <strong>rimuoverai definitivamente</strong> l'assegnazione del questionario per il seguente cliente.",
    assign_survey_confirm: "Conferma assegnazione questionario",
    assign_survey_confirm_message:
      "Sei sicuro di voler assegnare questo questionario?",
    assigned_to_customers: "Assegnato a <strong>{{count}}</strong> cliente",
    assigned_to_customers_plural:
      "Assegnato a <strong>{{count}}</strong> clienti",
    assigned_to_groups: "Assegnato a <strong>{{count}}</strong> gruppo",
    assigned_to_groups_plural: "Assegnato a <strong>{{count}}</strong> gruppi",
    customer: "Cliente",
    group: "Gruppo",
    members: "Membri",
    next: "Avanti",
    assign: "Assegna",
    search: "Cerca",
    selected: "Selezionati",
    no_results: "Nessun risultato trovato",
    loading: "Caricamento...",
    confirm_assignment: "Conferma assegnazione",
    cancel: "Annulla",
    close: "Chiudi",
    back_to_list: "Torna alla lista",
    survey_assigned_success: "Questionario assegnato con successo",
    survey_assigned_error: "Errore nell'assegnazione del questionario",
    survey_unassigned_success: "Questionario rimosso con successo",
    survey_unassigned_error: "Errore nella rimozione del questionario",
    survey_deleted_success: "Questionario eliminato con successo",
    survey_deleted_error: "Errore nell'eliminazione del questionario",
    submission_deleted_success: "Compilazione eliminata con successo",
    submission_deleted_error: "Errore nell'eliminazione della compilazione",
    edit_submission: "Modifica compilazione",
    view_submission: "Visualizza compilazione",
    no_submissions: "Nessuna compilazione presente",
    filter_submissions: "Filtra compilazioni",
    sort_by: "Ordina per",
    ascending: "Crescente",
    descending: "Decrescente",
    export_submissions: "Esporta compilazioni",
    import_submissions: "Importa compilazioni",
    submission_details: "Dettagli compilazione",
    submission_date_range: "Intervallo date compilazione",
    from_date: "Da",
    to_date: "A",
    apply_filters: "Applica filtri",
    clear_filters: "Cancella filtri",
    no_filters_applied: "Nessun filtro applicato",
    delete_submission_confirm:
      "Sei sicuro di voler eliminare questa compilazione?",
    assign_survey_to_customers: "Assegna questionario ai clienti",
    assign_survey_to_groups: "Assegna questionario ai gruppi",
    survey_assigned_successfully: "Questionario assegnato con successo",
    survey_assignment_error: "Errore nell'assegnazione del questionario",
    no_customers_selected: "Nessun cliente selezionato",
    no_groups_selected: "Nessun gruppo selezionato",
    select_customers_or_groups:
      "Seleziona clienti o gruppi per assegnare il questionario",
    confirm_survey_assignment: "Conferma assegnazione questionario",
    survey_details: "Dettagli questionario",
    assigned_to: "Assegnato a",
    assignment_summary: "Riepilogo assegnazione",
  },
  Tags: {
    error_tags: "Errore Tags",
    error_tags_subtitle: "Lista tags non caricata",
  },
  TrainingPlans: {
    title: "Piani di allenamento",
    titleMobile: "Allenamenti",
    add: "Aggiungi piano",
    exerciseLibrary: "Libreria esercizi",
    tagsLibrary: "Tipi Esercizio",
    tabs: {
      models: "Modelli",
      assignedPlans: "Piani assegnati",
    },
    error: {
      error_groups: "Errore Gruppi",
      error_groups_subtitle: "Errore gruppi",
    },
  },
  Vods: {
    label_empty_video_list: "Non ci sono video in questa Libreria",
    label_empty_customers_list: "Non ci sono clienti da assegnare",
    label_empty_groups_list: "Non ci sono gruppi da assegnare",
    video_in_progress_tooltip_title: "Video in elaborazione.",
    video_in_progress_tooltip_text: "Ricarica la pagina tra qualche minuto.",
    error: {
      vod: {
        title: "Errore Vod",
        subtitle: "Video non caricato",
        create: "Video non creata",
        delete: "Video non eliminato",
        edit: "Video non modificato",
        assign: "Video non assegnato",
        resolution: "La risoluzione del video supera il limite consentito (2K)",
      },
      vods: {
        title: "Errore Vods",
        subtitle: "Lista video non caricata",
      },
      playlist: {
        title: "Errore Playlist",
        subtitle: "Playlist non caricata",
        create: "Playlist non creata",
        delete: "Playlist non eliminata",
        edit: "Playlist non modificata",
        assign: "Playlist non assegnata",
      },
      playlists: {
        title: "Errore Playlists",
        subtitle: "Lista playlist non caricata",
      },
    },
    error_playlists: "Errore Playlists",
    error_playlists_subtitle: "Lista playlist non caricata",
    associated_users: "Utenti associati",
    weeks_duration: "Durata in settimane",
    date_of_start: "Data di inizio",
    assigned_to: "Assegnato a",
    members: "Membri",
    assign_video: "Assegna Video",
    assign_playlist: "Assegna Playlist",
    customer: "Cliente",
    group: "Gruppo",
    no_playlist_video: "Non ci sono video in questa Playlist",
    playlist: "Playlist",
    add_video_playlist: "Inserisci video in playlist",
    video: "Video",
    your_playlists: "Le tue playlist",
    playlist_video: "Video della playlist",
    sort_by_prefix: "Ordinamento:",
    sort_by_menu_aria: "Scegli come ordinare i video in questa playlist",
    sort_mode_manual: "Manuale",
    sort_mode_date_added_oldest_first: "Data di aggiunta (prima i più vecchi)",
    sort_mode_date_added_newest_first: "Data di aggiunta (prima i più recenti)",
    sort_mode_confirm_to_manual_title: "Passare all’ordine manuale?",
    sort_mode_confirm_to_date_asc_title:
      "Ordinare per data di aggiunta (prima i più vecchi)?",
    sort_mode_confirm_to_date_desc_title:
      "Ordinare per data di aggiunta (prima i più recenti)?",
    sort_mode_change_confirm_subtitle:
      "L'ordinamento verrà applicato a tutti i video della playlist. Potrai cambiarlo in qualsiasi momento.",
    sort_mode_switch_aria:
      "Cambia il modo in cui sono ordinati i video in playlist",
    sort_mode_switch_info_aria:
      "Per saperne di più sull’ordinamento della playlist",
    sort_mode_switch_tooltip:
      "Impostazione salvata per questa playlist. Ogni volta che cambi ordinamento, l’ordine dei video nell’elenco viene aggiornato di conseguenza.",
    sort_mode_drag_rows: "Trascina le righe per ordinarle.",
    sort_mode_mobile_reorder_hint:
      "Usa le frecce in alto a destra su ogni riga per spostare i video su o giù.",
    sort_mode_move_up_aria: "Sposta su",
    sort_mode_move_down_aria: "Sposta giù",
    sort_mode_remove_from_playlist_aria: "Rimuovi {{title}} dalla playlist",
    sort_mode_drag_handle_aria: "Trascina per riordinare",
    sort_mode_search_clears_drag:
      "Svuota la ricerca per trascinare e riordinare i video",
    playlist_vod_date_added_row: "Aggiunto il {{date}}",
    add_video: "Aggiungi video",
    edit_video: "Modifica video",
    info_message:
      "I tuoi video sono privati. Nessun altro Personal Trainer potrà vederli.",
    format_supported: "Formati supportati: MP4, MOV, WMV, AVI, FLV.",
    max_size: "Max {{size}}",
    name: "Nome",
    playlist_title: "Titolo Playlist",
    description: "Descrizione",
    category: "Categoria",
    loading: "Caricamento in corso",
    loading_alert:
      "Non lasciare questa pagina fino al termine del completamento",
    loading_initializing: "Inizializzazione",
    loading_stop: "Interrompi",
    loading_success: "Caricamento completato!",
    thumbnail_image: "Foto Copertina",
    options: "Opzioni",
    playlists: "Playlist",
    views: "Visualizzazioni",
    success_delete_video: "Elimina video",
    success_edit_video: "Modifica video",
    success_delete_video_subtitle: "Video eliminato con successo",
    success_assign_video: "Assegna video",
    success_assign_video_subtitle: "Video assegnato con successo",
    success_assign_playlist: "Assegna Playlist",
    success_assign_playlist_subtitle: "Playlist assegnata con successo",
    success_edit_video_subtitle: "Video modificato con successo",
    success_create_playlist_subtitle: "Playlist creato con successo",
    success_add_playlist_video_subtitle:
      "Video aggiunto alla Playlist con successo",
    success_delete_playlist_video_subtitle:
      "Video rimosso dalla Playlist con successo",
    success_delete_playlist_subtitle: "Playlist eliminata con successo",
    success_edit_playlist_subtitle: "Playlist modificata con successo",
    delete_video_title: "Vuoi eliminare questo video?",
    delete_video_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> il seguente video dalla lista.",
    title: "Titolo",
    video_bookshelf: "Libreria video",
    video_bookshelf_short: "Libreria",
    videos_ordering_shared_with_client_app:
      "L'ordinamento dei video è condiviso con l'applicazione di allenamento dei tuoi clienti. Tutte le modifiche che applicherai verranno condivise in tempo reale con l'app.",
    add_playlist: "Crea playlist",
    edit_playlist: "Modifica playlist",
    delete_playlist: "Elimina playlist",
    delete_playlist_title: "Vuoi eliminare questa playlist?",
    delete_playlist_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> la seguente playlist dalla lista.",
    monthly_views: "Visualizzazioni mensili",
    monthly_views_tooltip_title: "Attenzione!",
    monthly_views_tooltip_text:
      "Questa è una funzione premium, superate le {{views}} visualizzazioni mensili verrà automaticamente attivato il piano a pagamento. Clicca per maggiori informazioni.",
  },
  VodsStatistics: {
    title: "Visualizzazioni video",
    associatedGrup: "{{count}} gruppo",
    associatedGrup_other: "{{count}} gruppi",
    associatedCustomers: "{{count}} cliente",
    associatedCustomers_other: "{{count}} clienti",
    views: "{{count}} visualizzazione",
    views_other: "{{count}} visualizzazioni",
    columns: {
      video: "Video",
      associated: "Associato a",
      views: "Visualizzazioni",
    },
  },
  Attachments: {
    delete_attachment: "Vuoi eliminare questo allegato?",
    delete_attachment_subtitle:
      "Procedendo <strong>eliminerai definitivamente</strong><br /> l'allegato selezionato.",
    success: {
      create_attachment_title: "Crea Allegato",
      create_attachment: "Allegato creato con successo",
      edit_attachment_title: "Modifica Allegato",
      edit_attachment: "Allegato modificato con successo",
      delete_attachment_title: "Elimina Allegato",
      delete_attachment: "Allegato eliminato con successo",
    },
    error: {
      create_attachment_title: "Errore Creazione Allegato",
      create_attachment: "Errore nella creazione dell'allegato",
      edit_attachment_title: "Errore Modifica Allegato",
      edit_attachment: "Errore nella modifica dell'allegato",
      delete_attachment_title: "Errore Eliminazione Allegato",
      delete_attachment: "Errore nell'eliminazione dell'allegato",
    },
  },
  WorkoutStatistics: {
    title: "Feedback workout svolti",
    columns: {
      customer: "Cliente",
      feedback: "Feedback",
      last: "Ultimo workout",
    },
  },
  common: {
    copy_emails: {
      success_one: "{{count}} indirizzo copiato",
      success_other: "{{count}} indirizzi copiati",
      empty_title: "Nessun indirizzo copiato",
      empty_subtitle: "Le voci selezionate non hanno un indirizzo email",
      error_title: "Copia non riuscita",
      error_subtitle: "Non è stato possibile copiare gli indirizzi email",
    },
    apiError: {
      validation: "Controlla i dati inseriti: {{fields}}.",
      validation_generic: "Alcuni dati non sono stati accettati.",
      too_large: "Il file è troppo grande per essere caricato.",
      session: "La sessione è scaduta: ricarica la pagina e riprova.",
      forbidden: "Il tuo abbonamento non permette questa operazione.",
      server: "Errore del server: riprova fra qualche minuto.",
      network:
        "La richiesta non è arrivata al server. Controlla la connessione e non chiudere la finestra durante il caricamento.",
      generic: "Non è stato possibile completare l'operazione.",
      code: "Codice errore: {{code}} — riportalo all'assistenza.",
      field: {
        name: "nome",
        video: "video",
        image: "foto copertina",
        tags: "tag",
        link: "link video",
        note: "note",
      },
    },
    status: "Stato",
    activate: "Attiva",
    deactivate: "Disattiva",
    calendar: "Calendario",
    guide: "Guida",
    other: "Altro",
    document: "Documento",
    name: "Nome",
    category: "Categoria",
    coming_soon:
      "💡 Hai un'idea brillante o una richiesta? <button1><text>Clicca qui e raccontacela!</text></button1>",
    expand: "Espandi",
    reduce: "Riduci",
    print: "Stampa",
    understood: "Ho capito",
    download: "Scarica",
    no_data: "Nessun dato disponibile",
    refresh: "Aggiorna",
    every: "ogni",
    send_notification: "Invia notifica",
    view: "Visualizza",
    save_as_draft: "Salva come bozza",
    description: "Descrizione",
    date_of_start: "Data di inizio",
    detail: "Dettaglio",
    change: "Cambia",
    label_empty_table: "Nessun risultato trovato",
    write_us: "Scrivici",
    options: "Opzioni",
    export: "Esporta",
    attachments: "Allegati",
    nutrition: "Alimentazione",
    progress_module: "Modulo Progressi",
    list: "Lista",
    load_more: "Carica altro",
    remove: "Rimuovi",
    back: "Indietro",
    replace: "Sostituisci",
    assign: "Assegna",
    next: "Avanti",
    cancel: "Annulla",
    edit: "Modifica",
    delete: "Elimina",
    duplicate: "Duplica",
    compare: "Compara",
    manage_associates: "Gestisci associati",
    assign_playlist: "Assegna Playlist",
    add: "Aggiungi",
    create: "Crea",
    close: "Chiudi",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy - H:mm",
    dateFormatLong: "EEE dd LLL yyyy",
    date: "Data",
    timeFormat: "HH:mm",
    openLink: "Apri link",
    selected: "Selezionati",
    before: "prima",
    roles: {},
    error: {
      404: "Pagina non trovata",
      age_restriction: "Devi avere almeno 18 anni",
      required: "Obbligatorio",
      invalidLogin: "Indirizzo email non valido",
      email: "Indirizzo email non valido",
      max_date_today: "La data deve essere minore uguale a oggi",
      min_length: "Lunghezza minima non raggiunta",
      max_length: "Lunghezza massima superata",
      max_length_chars: "Massimo {{max}} caratteri",
      atLeastOne: "Devi compilare almeno un campo",
      fiscal_code: "Codice fiscale non valido",
      valid_url: "Url non valido",
      phone: "Numero di telefono non valido",
      must_match: "Le password devono corrispondere",
      postal_code: "Il CAP deve essere composto da 5 cifre",
      pec_or_ei_code_required:
        "È richiesto almeno un campo tra PEC e Codice Univoco",
      min_time: "Il tempo minimo è 15 minuti a partire da adesso",
      date_max_1_month:
        "La data di fine invio non può essere oltre un mese dalla data di inizio.",
      date_min_1_day:
        "La data di fine invio deve essere almeno un giorno dopo la data di inizio.",
      youtube_not_allowed: "I link YouTube non sono permessi in questo campo",
    },
    select_all: `Seleziona tutti`,
    select_placeholder: "Seleziona…",
    male: "Uomo",
    female: "Donna",
    gender_other: "Preferisco non dichiararlo",
    facebook: "Facebook",
    instagram: "Instagram",
    linkedin: "Linkedin",
    at_gym: "In palestra",
    word_of_mouth: "Passaparola",
    dont_know: "Non so",
    live: "Dal vivo",
    search: "Cerca",
    remote: "Remoto",
    reset: "Resetta",
    reset_all: "Resetta Filtri",
    groups: "Gruppi",
    filters: "Filtri",
    customers: "Clienti",
    end: "Fine",
    notes: "Note",
    start: "Inizio",
    label: "Etichetta",
    label_results: "Risultati",
    show_results: "Mostra Risultati",
    live_and_remote: "Dal vivo e remoto",
    active_chat: "Attiva chat per questo cliente",
    confirm: "Conferma",
    imageAvatar: {
      modalTitle: "Modifica immagine",
      modalTopBodyLabel:
        "Trascina l'immagine per selezionare l'area da tagliare",
      zoomLabel: "Regola lo zoom dell'immagine",
      previewAlt: "Anteprima",
      insertLabel: "Seleziona una foto oppure trascina",
      insertLabelMobile: "Scegli immagine",
      dropLabel: "Trascina il file qui...",
      errorLabel: "I file selezionati non sono validi",
      saveLabel: "Salva",
      cancelLabel: "Annulla",
    },
    save: "Salva",
    save_as_new: "Salva come nuovo",
    compositions: {
      weight: "Peso",
      bmr: "BMR",
      body_fat: "Grasso corporeo",
      body_temperature: "Temperatura corporea",
      metabolic_age: "Età metabolica",
      bmi: "BMI",
      lean_mass: "Massa magra",
      bone_mass: "Massa ossea",
      visceral_fat: "Grasso viscerale",
      tdee: "TDEE",
      tbw: "TBW",
      steps: "Passi",
      distance: "Distanza",
      calories: "Calorie",
      "nutrition.carbs.total": "Carboidrati",
      "nutrition.fat.total": "Grassi",
      "nutrition.protein": "Proteine",
    },
    health: {
      steps: "Passi",
      distance: "Distanza",
      calories: "Calorie",
      "nutrition.carbs.total": "Carboidrati",
      "nutrition.fat.total": "Grassi",
      "nutrition.protein": "Proteine",
    },
    plicometries: {
      protocol: "Protocollo",
      age: "Anni",
      gender: "Sesso",
      chest: "Petto",
      body_fat: "Grasso corporeo",
      subscapularis: "Subscapolare",
      axillary: "Ascellare",
      suprailiac: "Suprailiaca",
      abdominal: "Addominale",
      tricep: "Tricipite",
      bicep: "Bicipite",
      leg: "Coscia",
    },
    measurements: {
      chest: "Petto",
      shoulders: "Spalle",
      hip: "Fianchi",
      waist: "Vita",
      bicep: "Bicipiti",
      calf: "Polpacci",
      leg: "Coscia",
      wrist: "Polso",
      buttocks: "Glutei",
    },
    dates: {
      today: "Oggi",
      yearsAgo_one: "Un anno fa",
      yearsAgo_other: "{{count}} anni fa",
      monthsAgo_one: "Un mese fa",
      monthsAgo_other: "{{count}} mesi fa",
      weeksAgo_one: "Una settimana fa",
      weeksAgo_other: "{{count}} settimane fa",
      daysAgo_one: "Un giorno fa",
      daysAgo_other: "{{count}} giorni fa",
      hoursAgo_one: "Un'ora fa",
      hoursAgo_other: "{{count}} ore fa",
    },
    duration: {
      today: "Nessuna durata",
      yearsAgo_one: "Un anno",
      yearsAgo_other: "{{count}} anni",
      monthsAgo_one: "Un mese",
      monthsAgo_other: "{{count}} mesi",
      weeksAgo_one: "Una settimana",
      weeksAgo_other: "{{count}} settimane",
      daysAgo_one: "Un giorno",
      daysAgo_other: "{{count}} giorni",
      hoursAgo_one: "Un'ora",
      hoursAgo_other: "{{count}} ore",
    },
    cards_one: "{{count}} scheda",
    cards_other: "{{count}} schede",
    filterOptions: {
      satisfaction: {
        label: "Rating",
        0: "Non inserito",
        1: "🙂 Benissimo",
        2: "😐 Normale",
        3: "☹️ Male",
      },
      period: {
        label: "Periodo",
        lastweek: "Questa settimana",
        lastmonth: "Ultimo mese",
        last3month: "Ultimi 3 mesi",
        last6month: "Ultimi 6 mesi",
        lastyear: "Ultimo anno",
      },
    },
    search_customers: "Cerca clienti",
    search_groups: "Cerca gruppi",
    no_results_found: "Nessun risultato trovato",
    loading: "Caricamento...",
    deselect_all: "Deseleziona tutti",
    show_more: "Altro",
    show_less: "Meno",
  },
};
